<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        Usinas
      </div>
      <v-data-table
        :headers="headers"
        :items="dados"
        :loading="carregando"
        :server-items-length="total"
        :options.sync="options"
        loading-text="Carregando... Por favor aguarde"
        disable-sort
        class="elevation-1 base_table"
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
        <template v-slot:top>
          <v-row no-gutters align="center" justify="space-between">
            <div class="py-2 px-2">
              <v-row no-gutters align="center">
                <v-form @submit.prevent="buscaItens()">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="search"
                    outlined
                    label="Busca"
                    @click:clear="limparBusca()"
                  ></v-text-field>
                </v-form>
                <v-autocomplete
                  v-if="nivelUsuarioApelido === 'M'"
                  :menu-props="{ offsetY: true}"
                  class="ml-3"
                  :items="distribuidores"
                  label="Distribuidor"
                  append-icon="expand_more"
                  v-model="distribuidor"
                  hide-details=""
                  :loading="loading || loadingDistribuidores"
                  :disabled="loading || loadingDistribuidores"
                  outlined
                  @click:clear="() => {
                    this.options.page = 1
                    this.applyFilter()
                  }"
                  clearable
                  clear-icon="close"
                  @change="applyFilter()"
                ></v-autocomplete>
                <v-autocomplete
                  v-if="nivelUsuarioApelido === 'M' || nivelUsuarioApelido === 'D'"
                  :menu-props="{ offsetY: true}"
                  class="ml-3"
                  :items="integradores"
                  label="Integrador"
                  append-icon="expand_more"
                  v-model="integrador"
                  hide-details=""
                  :loading="loading || loadingIntegradores"
                  :disabled="loading || loadingIntegradores"
                  outlined
                  @click:clear="() => {
                    this.options.page = 1
                    this.applyFilter()
                  }"
                  clearable
                  clear-icon="close"
                  @change="applyFilter()"
                ></v-autocomplete>
              </v-row>
            </div>
            <div>
              <v-row>
                <v-col v-if="nivelUsuarioApelido === 'I'">
                  <v-btn
                    color="cancel"
                    @click="openDialogImportacao()"
                  >
                    Importar
                  </v-btn>
                </v-col>
                <v-col class="mr-3">
                  <v-menu
                    bottom
                    center
                    offset-y
                    max-height="400"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on">
                        Exportar
                        <v-icon>arrow_drop_down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="exportXls()">
                        <v-list-item-icon class="mr-1">
                          <v-icon color="primary">receipt_long</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Exportar para XLS</v-list-item-title>
                      </v-list-item>
                      <!-- <v-list-item @click="exportPdf()">
                        <v-list-item-icon class="mr-1">
                          <v-icon color="primary">assignment</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Exportar para PDF</v-list-item-title>
                      </v-list-item> -->
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>
            </div>
          </v-row>
        </template>
        <!-- <template v-slot:item.usi_desativada="{ item }">
          <v-chip v-if="item.usi_desativada" class="mw_status" color="green">Ativada</v-chip>
          <v-chip v-else class="mw_status" color="primary">Desativada</v-chip>
        </template> -->
        <template v-slot:item.usi_nome="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span class="cursor-pointer"  v-bind="attrs" v-on="on" @click="goToVisaoGeral(item)">
                {{item.usi_nome}}
              </span>
            </template>
            <span>Visualizar visão geral da usina</span>
          </v-tooltip>
          <v-chip v-if="item.usi_desativada" class="ml-2" small color="primary">Desativada</v-chip>
        </template>
        <template v-slot:item.acoes="{ item }">
          <v-row no-gutters justify="center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openNovo(item)" color="primary">
                  edit
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="opendialogDelete(item)" color="primary" class="mr-2 ml-2">
                  delete
                </v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="goToVisaoGeral(item)" color="primary">
                  visibility
                </v-icon>
              </template>
              <span>Visão geral da usina</span>
            </v-tooltip>
          </v-row>
        </template>
        <template v-slot:item.tipo_usina="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" color="primary" @click="openDialogDetalhes(item)">
                <!-- {{item.id === 1 ? 'solar_power' : item.id === 2 ? 'wind_power' : 'waterfall_chart'}} -->
                solar_power
              </v-icon>
            </template>
            <span>
              <!-- {{item.id === 1 ? 'Solar' : item.id === 2 ? 'Eólica' : 'Barragem'}} -->
              Detalhes da Usina
            </span>
          </v-tooltip>
        </template>
        <template v-slot:item.credito="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" color="primary" @click="openDialogCreditos(item)">
                savings
              </v-icon>
            </template>
            <span>Sistema de crédito</span>
          </v-tooltip>
        </template>
        <template v-slot:item.inversores="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" color="primary" @click="openDialogInversores(item)">
                sync_alt
              </v-icon>
            </template>
            <span>Inversores</span>
          </v-tooltip>
        </template>
        <template v-slot:item.producao_diaria="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" color="primary" @click="openDialogProducaoDiaria(item)">
                sunny
              </v-icon>
            </template>
            <span>Produção diária</span>
          </v-tooltip>
        </template>
        <template v-slot:item.producao_instantanea="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" color="primary" @click="openDialogProducaoInstantanea(item)">
                bolt
              </v-icon>
            </template>
            <span>Produção instantânea</span>
          </v-tooltip>
        </template>
        <template v-slot:item.indicadores="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" color="primary" @click="openDialogIndicadores(item)">
                touch_app
              </v-icon>
            </template>
            <span>Indicadores</span>
          </v-tooltip>
        </template>
        <template v-slot:item.ocorrencias="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" color="primary" @click="openDialogOcorrencias(item)">
                integration_instructions
              </v-icon>
            </template>
            <span>Ocorrências</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </div>
    <div class="ui-create">
      <v-btn color="primary" elevation="3" @click="openNovaUsina()" :loading="loading" :disabled="loading">
        <v-icon color="white" x-large>add</v-icon>
      </v-btn>
    </div>
    <v-dialog
      v-model="dialogNovo"
      persistent
      max-width="950px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{usina.uuid_usi_id ? 'Editar' : 'Nova'}} Usina
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogUsina()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formUsina">
          <v-row>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0">
              <v-text-field
                v-model="usina.usi_nome"
                autofocus
                label="Nome*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0" v-if="user && !user.uuid_int_id">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="usina.uuid_int_id"
                :items="integradoresCadastro"
                clearable
                clear-icon="close"
                label="Integrador*"
                :rules="[rules.required]"
                append-icon="expand_more"
                :loading="salvando || loadingIntegradores"
                @change="getClientes(usina.uuid_int_id)"
                :disabled="salvando || loadingIntegradores"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="usina.uuid_cli_id"
                :items="clientes"
                clearable
                clear-icon="close"
                label="Cliente*"
                :rules="[rules.required]"
                append-icon="expand_more"
                :loading="salvando || loadingClientes"
                :disabled="salvando || loadingClientes"
                outlined
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0" :class="user && !user.uuid_int_id ? 'pt-0' : ''">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="usina.uuid_uss_id"
                :items="status"
                clearable
                clear-icon="close"
                :rules="[rules.required]"
                label="Status*"
                append-icon="expand_more"
                :loading="salvando || loadingStatus"
                :disabled="salvando || loadingStatus"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field-cep
                v-model="usina.usi_cep"
                label="CEP*"
                :rules="[rules.required]"
                :loading="loadingCep || salvando"
                :disabled="loadingCep || salvando"
                @change="searchCep(usina.usi_cep)"
                v-bind:properties="{
                  disabled: false,
                  outlined: true,
                  clearable: true,
                  placeholder: '',
                }"
                @blur="getGeoposicao()"
                v-bind:options="{
                  outputMask: '########',
                  empty: null,
                  applyAfter: false,
                }"
              />
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-autocomplete
                v-model="usina.usi_uf"
                autocomplete="off"
                :items="estados"
                :loading="salvando || loadingEstados || loadingCep"
                :disabled="salvando || loadingEstados || loadingCep"
                label="Estado"
                append-icon="expand_more"
                outlined
                @change="filterCidade(usina.usi_uf)"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-autocomplete
                autocomplete="off"
                v-model="usina.usi_cidade"
                :items="cidadesFiltradas"
                :loading="salvando || loadingCidades || loadingCep"
                :disabled="salvando || loadingCidades || loadingCep"
                label="Cidade"
                append-icon="expand_more"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                v-model="usina.usi_bairro"
                outlined
                :loading="salvando || loadingCep"
                :disabled="salvando || loadingCep"
                label="Bairro"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                v-model="usina.usi_rua"
                outlined
                :loading="salvando || loadingCep"
                :disabled="salvando || loadingCep"
                label="Rua"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="pb-0 pt-0">
              <v-text-field
                v-model="usina.usi_numero"
                outlined
                :loading="salvando || loadingCep"
                :disabled="salvando || loadingCep"
                label="Número"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                v-model="usina.usi_complemento"
                outlined
                :loading="salvando || loadingCep"
                :disabled="salvando || loadingCep"
                label="Complemento"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" lg="3" xl="3" class="pt-0 pb-0">
              <v-text-field
                v-model="usina.usi_latitude"
                label="Latitude"
                outlined
                :disabled="salvando || loadingGeoposition"
                :loading="salvando || loadingGeoposition"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" lg="3" xl="3" class="pt-0 pb-0">
              <v-text-field
                v-model="usina.usi_longitude"
                label="Longitude"
                outlined
                :disabled="salvando || loadingGeoposition"
                :loading="salvando || loadingGeoposition"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pt-0" v-if="usina.usi_desativado_em">
              <!-- <v-menu
                ref="calendarData"
                v-model="calendarData"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    label="Data de desativação"
                    append-icon="calendar_today"
                    :loading="salvando"
                    :disabled="salvando || !usina.usi_desativada"
                    v-bind="attrs"
                    v-on="on"
                    v-model="dataFormatadaDesativada"
                    v-mask="'##/##/####'"
                    @input="() => {
                      calendarData = false
                      usina.data_desativada = $root.Formatter.parseDate(dataFormatadaDesativada)
                      updatePickerModalDataDesativada = $root.Formatter.parseDate(dataFormatadaDesativada)
                    }"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :picker-date.sync="updatePickerModalDataDesativada"
                  year-icon="calendar_today"
                  prev-icon="chevron_left"
                  next-icon="chevron_right"
                  :loading="salvando"
                  :disabled="salvando || !usina.usi_desativada"
                  v-model="dataDesativada"
                ></v-date-picker>
              </v-menu> -->
              <v-text-field
                v-model="usina.usi_desativado_em"
                label="Desativada"
                outlined
                :disabled="true"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" lg="3" xl="3" class="pt-0">
              <v-switch
                hide-details
                class="mt-1 ml-3"
                color="success"
                v-model="usina.usi_desativada"
                label="Desativada"
              ></v-switch>
            </v-col>
            <v-col cols="12" sm="9" md="9" lg="9" xl="9" class="pt-0"></v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pt-0 mt-4">
              <v-file-input
                show-size
                clearable
                ref="file"
                v-model="usina.usi_imagem"
                prepend-icon="image"
                label="Adicionar imagem"
                clear-icon="close"
                truncate-length="50"
                :loading="salvando"
                :disabled="salvando"
                v-if="isObject(usina.usi_imagem)"
                outlined
              ></v-file-input>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 mb-6" v-if="usina.usi_imagem && !isObject(usina.usi_imagem)">
              <v-row no-gutters justify="start" align="center">
                <div>
                  <div class="avatar" :style="`background-image: url('${usina && usina.usi_imagem ? usina.usi_imagem : require('@/assets/img/logo-icon.png')}')`"></div>
                </div>
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="dialogDeletarImagem = true" v-bind="attrs" v-on="on" color="primary">delete</v-icon>
                    </template>
                    <span>Remover imagem</span>
                  </v-tooltip>
                </div>
              </v-row>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 pb-0 mb-6">
              <v-row>
                <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pt-0 pb-0">
                  <v-autocomplete
                    autocomplete="off"
                    v-model="usina.interface"
                    :items="interfacesSelect"
                    :loading="salvando || loadingGeradores"
                    :disabled="salvando || loadingGeradores || verificaTipoUsuario(usina.uuid_int_id)"
                    label="Interface"
                    append-icon="expand_more"
                    outlined
                  ></v-autocomplete>
                    <!-- @change="getGeradores(usina.interface)" -->
                </v-col>
                <v-col cols="12" sm="8" md="8" lg="8" xl="8" class="pt-0 pb-0" v-if="usina.interface">
                  <v-row no-gutters>
                    <v-autocomplete
                      autocomplete="off"
                      v-model="usina.gerador"
                      :items="geradores"
                      :loading="salvando || loadingGeradores"
                      :disabled="salvando || loadingGeradores"
                      clearable
                      clear-icon="close"
                      :label="inversorLabel(usina.interface)"
                      hide-details=""
                      :search-input.sync="searchGerador"
                      @keyup="searchGeradores()"
                      append-icon="expand_more"
                      outlined
                    ></v-autocomplete>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="ui-btn-inherit add_gerador" :loading="loadingGeradores" :disabled="loadingGeradores" v-bind="attrs" v-on="on" @click="addGeradorInversor(usina.gerador)">
                          <v-icon color="primary">
                            add
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Adicionar Gerador</span>
                    </v-tooltip>
                  </v-row>
                </v-col>
              </v-row>
              <div v-if="geradoresAdicionados.length > 0">
                <v-divider class="mb-4 mt-3"></v-divider>
                <div class="text-h3 text-primary mb-4">
                  Geradores adicionados
                </div>
                <div v-for="(item, index) in geradoresAdicionados" :key="index">
                  <v-divider v-if="index !== 0" class="mb-5 mt-2"></v-divider>
                  <v-row align="center">
                    <v-col cols="12" sm="11" md="11" lg="11" xl="11">
                      <v-row>
                        <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="pb-0">
                          <v-text-field
                            :value="item.uge_interface_id === 1 ? 'SolarMaker' : item.uge_interface_id === 2 ? 'Renac' : item.uge_interface_id === 3 ? 'SolarMan' : item.interface"
                            label="Interface"
                            outlined
                            readonly
                            :disabled="salvando"
                            :loading="salvando"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="pb-0">
                          <v-text-field
                            :value="retornaStatusInterface(item.status ? item.status.uss_nome : item.status)"
                            label="Status"
                            outlined
                            readonly
                            :disabled="salvando"
                            :loading="salvando"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="pb-0">
                          <v-text-field
                            :value="item.id ? item.id : item.uge_integracao_id"
                            label="ID fabricante"
                            outlined
                            readonly
                            :disabled="salvando"
                            :loading="salvando"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
                          <v-text-field
                            :value="item.name ? item.name : item.uge_nome"
                            label="Nome"
                            outlined
                            readonly
                            :disabled="salvando"
                            :loading="salvando"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
                          <v-text-field
                            :value="item.location ? item.location : item.uge_local"
                            label="Endereço"
                            outlined
                            readonly
                            :disabled="salvando"
                            :loading="salvando"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
                          <v-text-field
                            :value="item.extra ? item.extra : item.uge_extras"
                            label="Extras"
                            outlined
                            readonly
                            :disabled="salvando"
                            :loading="salvando"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="1" md="1" lg="1" xl="1">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" @click="confirmaRemover(item, index)" :disabled="salvando" :loading="salvando" color="primary" class="ml-2">
                            delete
                          </v-icon>
                        </template>
                        <span>Remover gerador</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
              </div>
              <div v-if="inversoresAdicionados.length > 0">
                <v-divider class="mb-4 mt-3"></v-divider>
                <div class="text-h3 text-primary mb-4">
                  Inversores adicionados
                </div>
                <div v-for="(item, index) in inversoresAdicionados" :key="index">
                  <v-divider v-if="index !== 0" class="mb-5 mt-2"></v-divider>
                  <v-row align="center">
                    <v-col cols="12" sm="11" md="11" lg="11" xl="11">
                      <v-row>
                        <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="pb-0">
                          <v-text-field
                            :value="getInterfaceNameByValue(item.interface_id || item.inversor.inv_interface)"
                            label="Interface"
                            outlined
                            readonly
                            :disabled="salvando"
                            :loading="salvando"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="pb-0">
                          <v-text-field
                            :value="retornaStatusInterface(item.status || item.status === 0 ? item.status : item.inversor.inv_status)"
                            label="Status"
                            outlined
                            readonly
                            :disabled="salvando"
                            :loading="salvando"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="pb-0">
                          <v-text-field
                            :value="item.id ? item.id : item.inversor.inv_id_integracao"
                            label="ID fabricante"
                            outlined
                            readonly
                            :disabled="salvando"
                            :loading="salvando"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
                          <v-text-field
                            :value="item.sn || item.inversor.inv_serial"
                            label="Número de Série"
                            outlined
                            readonly
                            :disabled="salvando"
                            :loading="salvando"
                          ></v-text-field>
                        </v-col>
                        <!-- <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
                          <v-text-field
                            :value="item.location ? item.location : item.uge_local"
                            label="Endereço"
                            outlined
                            readonly
                            :disabled="salvando"
                            :loading="salvando"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
                          <v-text-field
                            :value="item.extra ? item.extra : item.uge_extras"
                            label="Extras"
                            outlined
                            readonly
                            :disabled="salvando"
                            :loading="salvando"
                          ></v-text-field>
                        </v-col> -->
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="1" md="1" lg="1" xl="1">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" @click="confirmaRemoverInversor(item, index)" :disabled="salvando" :loading="salvando" color="primary" class="ml-2">
                            delete
                          </v-icon>
                        </template>
                        <span>Remover inversor</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-col>
          </v-row>
         </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="closeDialogUsina()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditUsina()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeletarImagem" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover Imagem
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogDeletarImagem = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja remover a imagem?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogDeletarImagem = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeImagem()"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluirInversorAdicionado" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover Inversor
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogExcluirInversorAdicionado = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja remover Inversor <b class="text-primary">{{inversorDetalhe ? inversorDetalhe.id : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogExcluirInversorAdicionado = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removerInversor(inversorDetalheIndex)"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluirGerador" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover Gerador
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogExcluirGerador = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja remover Gerador <b class="text-primary">{{geradorDetalhe ? geradorDetalhe.uge_nome : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogExcluirGerador = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removerGerador(geradorDetalheIndex)"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Usina
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelDialogDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Usina <b class="text-primary">{{usina ? usina.usi_nome : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="cancelDialogDelete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeUsina()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogUsina"
      persistent
      max-width="1050px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{usina ? usina.usi_nome : ''}}
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogDetalhesUsina()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formUsinaDetalhes">
          <v-row>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0">
              <v-text-field-percent
                autofocus
                :rules="[rules.required]"
                label="Potência (kWp)*"
                outlined
                v-model="usina_detalhes.usp_potencia"
                v-bind:properties="{
                  readonly: false,
                  disabled: false,
                  outlined: true,
                  disabled: salvando,
                  loading: salvando
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 4,
                  precision: 2,
                  empty: 0,
                }"
              ></v-text-field-percent>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0">
              <v-text-field-percent
                autofocus
                :rules="[rules.required]"
                label="Eficiência*"
                outlined
                v-model="usina_detalhes.usp_eficiencia"
                v-bind:properties="{
                  readonly: false,
                  disabled: false,
                  outlined: true,
                  disabled: salvando,
                  loading: salvando
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 4,
                  precision: 2,
                  empty: 0,
                }"
              ></v-text-field-percent>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0">
              <v-menu
                ref="calendarDataInstalacao"
                v-model="calendarDataInstalacao"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    label="Data da instalação"
                    append-icon="calendar_today"
                    :loading="salvando"
                    :disabled="salvando"
                    v-bind="attrs"
                    v-on="on"
                    v-model="dataFormatadaInstalacao"
                    v-mask="'##/##/####'"
                    @input="() => {
                      calendarDataInstalacao = false
                      usina_detalhes.usp_data_instalacao = $root.Formatter.parseDate(dataFormatadaInstalacao)
                      updatePickerModalDataInstalacao = $root.Formatter.parseDate(dataFormatadaInstalacao)
                    }"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :picker-date.sync="updatePickerModalDataInstalacao"
                  year-icon="calendar_today"
                  prev-icon="chevron_left"
                  next-icon="chevron_right"
                  :loading="salvando"
                  :disabled="salvando"
                  v-model="dataInstalacao"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pt-0 pb-0">
              <vuetify-money
                lazy-validation
                v-model="usina_detalhes.usp_total_investido"
                :backgroundColor="$vuetify.theme.dark ? '#1e1e1e00' : '#fff'"
                :disabled="salvando"
                :loading="salvando"
                outlined
                :options="optionsMoney"
                valueWhenIsEmpty="0,00"
                label="Total investido"
              ></vuetify-money>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pt-0 pb-0">
              <v-text-field-percent
                label="Tarifa de referência"
                outlined
                v-model="usina_detalhes.usp_tarifa_referencia"
                v-bind:properties="{
                  readonly: false,
                  disabled: false,
                  outlined: true,
                  disabled: salvando,
                  loading: salvando
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 4,
                  precision: 2,
                  empty: 0,
                }"
              ></v-text-field-percent>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pt-0 pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="usina_detalhes.uuid_uss_id"
                :items="status"
                clearable
                clear-icon="close"
                :rules="[rules.required]"
                label="Status*"
                append-icon="expand_more"
                :loading="salvando || loadingStatus"
                :disabled="salvando || loadingStatus"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-text-field-percent
                label="Rendimento anual (h)"
                outlined
                :value="usina && usina_detalhes.usp_rsi_jan ? rendimentoAnual() : 0"
                v-bind:properties="{
                  readonly: false,
                  disabled: true,
                  outlined: true,
                  loading: salvando
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 4,
                  precision: 2,
                  empty: 0,
                }"
              ></v-text-field-percent>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-text-field-percent
                outlined
                :value="usina && usina_detalhes.usp_rsi_jan ? geracaoAnualPrevista() : 0"
                label="Geração anual prevista (kWh)"
                v-bind:properties="{
                  readonly: false,
                  disabled: true,
                  outlined: true,
                  loading: salvando
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 4,
                  precision: 2,
                  empty: 0,
                }"
              ></v-text-field-percent>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
              <v-row align="center">
                <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                  <v-btn
                    color="primary"
                    :loading="salvando"
                    :disabled="salvando"
                    class="consulta"
                    @click="getDadosRSI()"
                  >
                    Consultar RSI
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4" xl="4" v-if="selectRSI.length > 0">
                  <v-autocomplete
                    :menu-props="{ offsetY: true}"
                    :items="selectRSI"
                    clearable
                    clear-icon="close"
                    hide-details=""
                    :rules="[rules.required]"
                    v-model="usina_detalhes.rsiSelect"
                    label="Estação*"
                    @change="selecionaEstacaoRSI()"
                    append-icon="expand_more"
                    :loading="salvando"
                    :disabled="salvando"
                    outlined
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-col>
            <!-- <v-col cols="12" sm="3" md="3" lg="3" xl="3" v-if="usina_detalhes.angulo">
              <v-text-field
                v-model="usina_detalhes.angulo"
                label="Ângulo"
                outlined
                hide-details=""
                :disabled="true"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2" v-if="usina_detalhes.distancia">
              <v-text-field
                v-model="usina_detalhes.distancia"
                label="Distância"
                outlined
                hide-details=""
                :disabled="true"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" lg="3" xl="3" v-if="usina_detalhes.estacao">
              <v-text-field
                v-model="usina_detalhes.estacao"
                label="Estação"
                outlined
                hide-details=""
                :disabled="true"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2" v-if="usina_detalhes.inclinicao">
              <v-text-field
                v-model="usina_detalhes.inclinicao"
                label="Inclinação"
                outlined
                hide-details=""
                :disabled="true"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2" v-if="usina_detalhes.municipio">
              <v-text-field
                v-model="usina_detalhes.municipio"
                label="Município"
                outlined
                hide-details=""
                :disabled="true"
                :loading="salvando"
              ></v-text-field>
            </v-col> -->
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 pb-0"></v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2">
              <v-text-field
                autofocus
                :rules="[rules.required]"
                label="RSI Janeiro*"
                suffix="h"
                outlined
                v-model="usina_detalhes.usp_rsi_jan"
                :disabled="salvando"
                :loading="salvando"
                :hideDetails="true"
                :readonly="true"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 4,
                  precision: 2,
                  empty: 0,
                }"
              ></v-text-field>
                <v-text-field
                  class="mt-2"
                  v-model="usina_detalhes.usp_objetivo_minimo_jan"
                  label="Objetivo Mínimo"
                  outlined
                  hide-details=""
                  suffix="kWh"
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
              <div class="value_area">
                {{returnvalorRSIMes(usina_detalhes.usp_rsi_jan, 1)}} kWh
              </div>
              <div class="value_area_porcentagem">
                {{returnvalorRSIPorcentagem(usina_detalhes.usp_rsi_jan, 1)}}
              </div>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2">
              <v-text-field
                autofocus
                :rules="[rules.required]"
                label="RSI Fevereiro*"
                suffix="h"
                outlined
                v-model="usina_detalhes.usp_rsi_fev"
                :disabled="salvando"
                :loading="salvando"
                :hideDetails="true"
                :readonly="true"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 4,
                  precision: 2,
                  empty: 0,
                }"
              ></v-text-field>
              <v-text-field
                class="mt-2"
                v-model="usina_detalhes.usp_objetivo_minimo_fev"
                label="Objetivo Mínimo"
                outlined
                hide-details=""
                suffix="kWh"
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
              <div class="value_area">
                {{returnvalorRSIMes(usina_detalhes.usp_rsi_fev, 2)}} kWh
              </div>
              <div class="value_area_porcentagem">
                {{returnvalorRSIPorcentagem(usina_detalhes.usp_rsi_fev, 2)}}
              </div>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2">
              <v-text-field
                autofocus
                :rules="[rules.required]"
                label="RSI Março*"
                suffix="h"
                outlined
                v-model="usina_detalhes.usp_rsi_mar"
                :disabled="salvando"
                :loading="salvando"
                :hideDetails="true"
                :readonly="true"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 4,
                  precision: 2,
                  empty: 0,
                }"
              ></v-text-field>
              <v-text-field
                class="mt-2"
                v-model="usina_detalhes.usp_objetivo_minimo_mar"
                label="Objetivo Mínimo"
                outlined
                hide-details=""
                suffix="kWh"
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
              <div class="value_area">
                {{returnvalorRSIMes(usina_detalhes.usp_rsi_mar, 3)}} kWh
              </div>
              <div class="value_area_porcentagem">
                {{returnvalorRSIPorcentagem(usina_detalhes.usp_rsi_mar, 3)}}
              </div>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2">
              <v-text-field
                autofocus
                :rules="[rules.required]"
                label="RSI Abril*"
                suffix="h"
                outlined
                v-model="usina_detalhes.usp_rsi_abr"
                :disabled="salvando"
                :loading="salvando"
                :hideDetails="true"
                :readonly="true"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 4,
                  precision: 2,
                  empty: 0,
                }"
              ></v-text-field>
              <v-text-field
                class="mt-2"
                v-model="usina_detalhes.usp_objetivo_minimo_abr"
                label="Objetivo Mínimo"
                outlined
                hide-details=""
                suffix="kWh"
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
              <div class="value_area">
                {{returnvalorRSIMes(usina_detalhes.usp_rsi_abr, 4)}} kWh
              </div>
              <div class="value_area_porcentagem">
                {{returnvalorRSIPorcentagem(usina_detalhes.usp_rsi_abr, 4)}}
              </div>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2">
              <v-text-field
                autofocus
                :rules="[rules.required]"
                label="RSI Maio*"
                suffix="h"
                outlined
                v-model="usina_detalhes.usp_rsi_mai"
                :disabled="salvando"
                :loading="salvando"
                :hideDetails="true"
                :readonly="true"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 4,
                  precision: 2,
                  empty: 0,
                }"
              ></v-text-field>
              <v-text-field
                class="mt-2"
                v-model="usina_detalhes.usp_objetivo_minimo_mai"
                label="Objetivo Mínimo"
                outlined
                hide-details=""
                suffix="kWh"
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
              <div class="value_area">
                {{returnvalorRSIMes(usina_detalhes.usp_rsi_mai, 5)}} kWh
              </div>
              <div class="value_area_porcentagem">
                {{returnvalorRSIPorcentagem(usina_detalhes.usp_rsi_mai, 5)}}
              </div>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2">
              <v-text-field
                autofocus
                :rules="[rules.required]"
                label="RSI Junho*"
                suffix="h"
                outlined
                v-model="usina_detalhes.usp_rsi_jun"
                :disabled="salvando"
                :loading="salvando"
                :hideDetails="true"
                :readonly="true"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 4,
                  precision: 2,
                  empty: 0,
                }"
              ></v-text-field>
              <v-text-field
                class="mt-2"
                v-model="usina_detalhes.usp_objetivo_minimo_jun"
                label="Objetivo Mínimo"
                outlined
                hide-details=""
                suffix="kWh"
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
              <div class="value_area">
                {{returnvalorRSIMes(usina_detalhes.usp_rsi_jun, 6)}} kWh
              </div>
              <div class="value_area_porcentagem">
                {{returnvalorRSIPorcentagem(usina_detalhes.usp_rsi_jun, 6)}}
              </div>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2">
              <v-text-field
                autofocus
                :rules="[rules.required]"
                label="RSI Julho*"
                suffix="h"
                outlined
                v-model="usina_detalhes.usp_rsi_jul"
                :disabled="salvando"
                :loading="salvando"
                :hideDetails="true"
                :readonly="true"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 4,
                  precision: 2,
                  empty: 0,
                }"
              ></v-text-field>
              <v-text-field
                class="mt-2"
                v-model="usina_detalhes.usp_objetivo_minimo_jul"
                label="Objetivo Mínimo"
                outlined
                hide-details=""
                suffix="kWh"
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
              <div class="value_area">
                {{returnvalorRSIMes(usina_detalhes.usp_rsi_jul, 7)}} kWh
              </div>
              <div class="value_area_porcentagem">
                {{returnvalorRSIPorcentagem(usina_detalhes.usp_rsi_jul, 7)}}
              </div>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2">
              <v-text-field
                autofocus
                :rules="[rules.required]"
                label="RSI Agosto*"
                suffix="h"
                outlined
                v-model="usina_detalhes.usp_rsi_ago"
                :disabled="salvando"
                :loading="salvando"
                :hideDetails="true"
                :readonly="true"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 4,
                  precision: 2,
                  empty: 0,
                }"
              ></v-text-field>
              <v-text-field
                class="mt-2"
                v-model="usina_detalhes.usp_objetivo_minimo_ago"
                label="Objetivo Mínimo"
                outlined
                hide-details=""
                suffix="kWh"
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
              <div class="value_area">
                {{returnvalorRSIMes(usina_detalhes.usp_rsi_ago, 8)}} kWh
              </div>
              <div class="value_area_porcentagem">
                {{returnvalorRSIPorcentagem(usina_detalhes.usp_rsi_ago, 8)}}
              </div>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2">
              <v-text-field
                autofocus
                :rules="[rules.required]"
                label="RSI Setembro*"
                suffix="h"
                outlined
                v-model="usina_detalhes.usp_rsi_set"
                :disabled="salvando"
                :loading="salvando"
                :hideDetails="true"
                :readonly="true"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 4,
                  precision: 2,
                  empty: 0,
                }"
              ></v-text-field>
              <v-text-field
                class="mt-2"
                v-model="usina_detalhes.usp_objetivo_minimo_set"
                label="Objetivo Mínimo"
                outlined
                hide-details=""
                suffix="kWh"
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
              <div class="value_area">
                {{returnvalorRSIMes(usina_detalhes.usp_rsi_set, 9)}} kWh
              </div>
              <div class="value_area_porcentagem">
                {{returnvalorRSIPorcentagem(usina_detalhes.usp_rsi_set, 9)}}
              </div>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2">
              <v-text-field
                autofocus
                :rules="[rules.required]"
                label="RSI Outubro*"
                suffix="h"
                outlined
                v-model="usina_detalhes.usp_rsi_out"
                :disabled="salvando"
                :loading="salvando"
                :hideDetails="true"
                :readonly="true"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 4,
                  precision: 2,
                  empty: 0,
                }"
              ></v-text-field>
              <v-text-field
                class="mt-2"
                v-model="usina_detalhes.usp_objetivo_minimo_out"
                label="Objetivo Mínimo"
                outlined
                hide-details=""
                suffix="kWh"
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
              <div class="value_area">
                {{returnvalorRSIMes(usina_detalhes.usp_rsi_out, 10)}} kWh
              </div>
              <div class="value_area_porcentagem">
                {{returnvalorRSIPorcentagem(usina_detalhes.usp_rsi_out, 10)}}
              </div>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2">
              <v-text-field
                autofocus
                :rules="[rules.required]"
                label="RSI Novembro*"
                suffix="h"
                outlined
                v-model="usina_detalhes.usp_rsi_nov"
                :disabled="salvando"
                :loading="salvando"
                :hideDetails="true"
                :readonly="true"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 4,
                  precision: 2,
                  empty: 0,
                }"
              ></v-text-field>
              <v-text-field
                class="mt-2"
                v-model="usina_detalhes.usp_objetivo_minimo_nov"
                label="Objetivo Mínimo"
                outlined
                hide-details=""
                suffix="kWh"
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
              <div class="value_area">
                {{returnvalorRSIMes(usina_detalhes.usp_rsi_nov, 11)}} kWh
              </div>
              <div class="value_area_porcentagem">
                {{returnvalorRSIPorcentagem(usina_detalhes.usp_rsi_nov, 11)}}
              </div>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2">
              <v-text-field
                v-model="usina_detalhes.usp_rsi_dez"
                label="RSI Dezembro*"
                outlined
                suffix="h"
                :rules="[rules.required]"
                autofocus
                :disabled="salvando"
                :loading="salvando"
                :hideDetails="true"
                :readonly="true"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 4,
                  precision: 2,
                  empty: 0,
                }"
              ></v-text-field>
              <v-text-field
                class="mt-2"
                v-model="usina_detalhes.usp_objetivo_minimo_dez"
                label="Objetivo Mínimo"
                outlined
                hide-details=""
                suffix="kWh"
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
              <div class="value_area">
                {{returnvalorRSIMes(usina_detalhes.usp_rsi_dez, 12)}} kWh
              </div>
              <div class="value_area_porcentagem">
                {{returnvalorRSIPorcentagem(usina_detalhes.usp_rsi_dez, 12)}}
              </div>
            </v-col>
          </v-row>
        </v-form>
        <v-divider class="mt-4"></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="closeDialogDetalhesUsina()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="editDetalhesUsina()"
            :loading="salvando"
            :disabled="salvando"
            v-if="!isIntegrador() || $root.Permissions.validate(['usinas:detalhes-da-usina:visualizar'])"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogCreditos"
      persistent
      max-width="1000px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="8">
            Sistema de Crédito
          </v-col>
          <v-col cols="4" class="text-right">
            <v-row no-gutters align="center" justify="end">
              <v-btn @click="dialogNovoCredito = true" color="primary" class="mr-3" v-if="!isIntegrador() || $root.Permissions.validate(['usinas:sistema-de-credito:visualizar'])">Novo sistema de crédito</v-btn>
              <v-icon @click="dialogCreditos = false">close</v-icon>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div>
          <v-data-table
            :headers="headersCreditos"
            :items="dadosCreditos"
            :search="searchCreditos"
            loading-text="Carregando... Por favor aguarde"
            :loading="carregandoCreditos"
            multi-sort
            fixed-header
            height="400px"
            class="elevation-1 base_table"
            :footer-props="{
              itemsPerPageOptions: [5,10,15,20,25,50,100],
              showFirstLastPage: true,
              firstIcon: 'skip_previous',
              lastIcon: 'skip_next',
              prevIcon: 'chevron_left',
              nextIcon: 'chevron_right'
            }"
            :header-props="{
              sortIcon: 'north',
            }"
          >
            <template v-slot:top>
              <v-row no-gutters align="center" justify="space-between">
                <div class="py-2 px-2 table_search_area">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="searchCreditos"
                    outlined
                    label="Busca"
                  ></v-text-field>
                </div>
                <!-- <div>
                  <v-menu
                    bottom
                    center
                    offset-y
                    max-height="400"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        Exportar
                        <v-icon>arrow_drop_down</v-icon>
                      </div>
                    </template>
                    <v-list>
                      <v-list-item @click="''">
                        <v-list-item-icon class="mr-1">
                          <v-icon color="primary">receipt_long</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Exportar para XLS</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="''">
                        <v-list-item-icon class="mr-1">
                          <v-icon color="primary">assignment</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Exportar para TXT</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div> -->
              </v-row>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-row no-gutters align="center" justify="center" v-if="!isIntegrador() || $root.Permissions.validate(['usinas:sistema-de-credito:visualizar'])">
               <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="openNovoCredito(item)" color="primary" class="mr-2">
                      edit
                    </v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="opendialogDeleteCredito(item)" color="primary" class="ml-2">
                      delete
                    </v-icon>
                  </template>
                  <span>Excluir</span>
                </v-tooltip>
              </v-row>
            </template>
          </v-data-table>
        </div>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            @click="dialogCreditos = false"
          >
            Fechar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluirCredito" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Sistema de crédito
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelDialogDeleteCredito()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Sistema de crédito <b class="text-primary">{{credito ? credito.usc_id : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="cancelDialogDeleteCredito()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeCredito()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogNovoCredito"
      persistent
      max-width="400px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{credito.uuid_usc_id ? 'Editar' : 'Novo'}} Sistema de Crédito
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogCreditos()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formCredito">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="credito.uuid_uco_id"
                :items="unidades"
                clearable
                clear-icon="close"
                label="Unidade consumidora*"
                :rules="[rules.required]"
                append-icon="expand_more"
                :loading="salvando || loadingUnidades"
                :disabled="salvando || loadingUnidades"
                outlined
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
              <v-menu
                ref="calendarDataVigencia"
                v-model="calendarDataVigencia"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    label="Vigência*"
                    :rules="[rules.required]"
                    append-icon="calendar_today"
                    :loading="salvando"
                    :disabled="salvando"
                    v-bind="attrs"
                    v-on="on"
                    v-model="dataFormatadaVigencia"
                    v-mask="'##/##/####'"
                    @input="() => {
                      calendarDataVigencia = false
                      credito.usc_vigencia = $root.Formatter.parseDate(dataFormatadaVigencia)
                      updatePickerModalDataVigencia = $root.Formatter.parseDate(dataFormatadaVigencia)
                    }"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :picker-date.sync="updatePickerModalDataVigencia"
                  year-icon="calendar_today"
                  prev-icon="chevron_left"
                  next-icon="chevron_right"
                  :loading="salvando"
                  :disabled="salvando"
                  v-model="dataVigencia"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
              <v-text-field-percent
                label="Percentual*"
                :disabled="salvando"
                :rules="[rules.required]"
                :loading="salvando"
                outlined
                v-model="credito.usc_percentual"
                v-bind:properties="{
                  suffix: '%',
                  readonly: false,
                  disabled: false,
                  outlined: true,
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 4,
                  precision: 2,
                  empty: 0,
                }"
              ></v-text-field-percent>
            </v-col>
          </v-row>
        </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="closeDialogCreditos()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditCredito()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogInversor"
      persistent
      max-width="1100px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="9">
            Inversores
          </v-col>
          <v-col cols="3" class="text-right">
            <v-row no-gutters align="center" justify="end">
              <!-- <v-btn @click="dialogNovoInversor = true" color="primary" class="mr-3">Novo inversor</v-btn> -->
              <v-icon @click="dialogInversor = false">close</v-icon>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-data-table
          :headers="headersInversores"
          :items="dadosInversores"
          :search="searchInversores"
          :loading="carregandoInversores"
          loading-text="Carregando... Por favor aguarde"
          multi-sort
          fixed-header
          height="400px"
          class="elevation-1 base_table"
          :footer-props="{
            itemsPerPageOptions: [5,10,15,20,25,50,100],
            showFirstLastPage: true,
            firstIcon: 'skip_previous',
            lastIcon: 'skip_next',
            prevIcon: 'chevron_left',
            nextIcon: 'chevron_right'
          }"
          :header-props="{
            sortIcon: 'north',
          }"
        >
          <template v-slot:top>
            <v-row no-gutters align="center" justify="space-between">
              <div class="py-2 px-2 table_search_area">
                <v-text-field
                  clearable
                  hide-details=""
                  clear-icon="close"
                  v-model="searchInversores"
                  outlined
                  label="Busca"
                ></v-text-field>
              </div>
              <!-- <div>
                <v-menu
                  bottom
                  center
                  offset-y
                  max-height="400"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      Exportar
                      <v-icon>arrow_drop_down</v-icon>
                    </div>
                  </template>
                  <v-list>
                    <v-list-item @click="''">
                      <v-list-item-icon class="mr-1">
                        <v-icon color="primary">receipt_long</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Exportar para XLS</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="''">
                      <v-list-item-icon class="mr-1">
                        <v-icon color="primary">assignment</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Exportar para TXT</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div> -->
            </v-row>
          </template>
          <template v-slot:item.inversor.inv_marca="{ item }">
            {{item.inversor.inv_marca}}
            <v-chip v-if="!item.inversor.inv_status" class="ml-2" small color="primary">Inativo</v-chip>
          </template>
           <template v-slot:item.inversor.inv_interface="{ item }">
            {{returnInterface(item.inversor.inv_interface)}}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-row no-gutters align="center" justify="center" v-if="!isIntegrador() || $root.Permissions.validate(['usinas:inversores:visualizar'])">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" @click="openNovoInversor(item)" color="primary" class="mr-2">
                    edit
                  </v-icon>
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" @click="opendialogDeleteInversor(item)" color="primary" class="ml-2">
                    delete
                  </v-icon>
                </template>
                <span>Excluir</span>
              </v-tooltip>
            </v-row>
          </template>
        </v-data-table>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            @click="dialogInversor = false"
          >
            Fechar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogNovoInversor"
      persistent
      max-width="700px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{inversorPai.inversor.uuid_inv_id ? 'Editar' : 'Novo'}} Inversor
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogInversores()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formInversor">
          <v-row>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="inversorPai.inversor.uuid_uss_id"
                :items="status"
                clearable
                clear-icon="close"
                :rules="[rules.required]"
                label="Status*"
                append-icon="expand_more"
                :loading="salvando || loadingStatus"
                :disabled="salvando || loadingStatus"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
              <v-menu
                ref="calendarDataGarantia"
                v-model="calendarDataGarantia"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    label="Garantia"
                    append-icon="calendar_today"
                    :loading="salvando"
                    :disabled="salvando"
                    v-bind="attrs"
                    v-on="on"
                    v-model="dataFormatadaGarantia"
                    v-mask="'##/##/####'"
                    @input="() => {
                      calendarDataGarantia = false
                      inversorPai.inversor.inv_garantia = $root.Formatter.parseDate(dataFormatadaGarantia)
                      updatePickerModalDataGarantia = $root.Formatter.parseDate(dataFormatadaGarantia)
                    }"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :picker-date.sync="updatePickerModalDataGarantia"
                  year-icon="calendar_today"
                  prev-icon="chevron_left"
                  next-icon="chevron_right"
                  :loading="salvando"
                  :disabled="salvando"
                  v-model="dataGarantia"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="inversorPai.inversor.inv_tipo"
                :items="tipos"
                clearable
                clear-icon="close"
                label="Tipo de Alimentação"
                append-icon="expand_more"
                :loading="salvando"
                :disabled="salvando"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field
                v-model="inversorPai.inversor.inv_marca"
                autofocus
                label="Marca"
                outlined
                :disabled="salvando"
                :loading="salvando || loadingInversorSelecionado"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
               <v-text-field
                v-model="inversorPai.inversor.inv_modelo"
                label="Modelo"
                outlined
                :disabled="salvando"
                :loading="salvando || loadingInversorSelecionado"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field
                v-model="inversorPai.inversor.inv_potencia"
                label="Potência KW"
                outlined
                :disabled="salvando"
                :loading="salvando || loadingInversorSelecionado"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field
                v-model="inversorPai.inversor.inv_serial"
                label="Número Serial"
                outlined
                :rules="[rules.required]"
                :loading="salvando || loadingInversorSelecionado"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field
                v-model="inversorPai.inversor.inv_localizacao"
                label="Localização"
                outlined
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-text-field
                v-model="inversorPai.inu_painel_quantidade"
                label="Quantidade de painéis*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-text-field
                v-model="inversorPai.inu_painel_potencia"
                label="Potência do painel*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0">
              <v-switch
                hide-details
                class="mt-0 ml-3 mb-4"
                color="success"
                v-model="inversorPai.inversor.inv_status"
                :label="inversorPai.inversor.inv_status ? 'Ativo' : 'Inativo'"
              ></v-switch>
            </v-col>
          </v-row>
        </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between" v-if="!isIntegrador() || $root.Permissions.validate(['usinas:inversores:visualizar'])">
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="closeDialogInversores()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditInversor()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluirInversor" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Inversor
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelDialogDeleteInversor()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Inversor <b class="text-primary">{{inversorPai ? inversorPai.inu_id : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="cancelDialogDeleteInversor()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeInversor()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <!-- <v-dialog
      v-model="dialogProducaoDiaria"
      persistent
      max-width="800px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="9">
            Produção diária da <b>Usina Luciano</b>
          </v-col>
          <v-col cols="3" class="text-right">
            <v-icon @click="dialogProducaoDiaria = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-row align="center">
          <v-col cols="12" sm="9" md="9" lg="9" xl="9" class="pt-0">
            <v-simple-table class="base_table" fixed-header height="400px">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      ID
                    </th>
                    <th class="text-center">
                      Data
                    </th>
                    <th class="text-center">
                      Produção
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(index) in 10" :key="index">
                    <td class="text-left">{{index+1}}</td>
                    <td class="text-center">21/07/2022</td>
                    <td class="text-center">399</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col cols="12" sm="3" md="3" lg="3" xl="3" class="pt-0 text-center">
            <v-btn color="success" class="mb-3 w-100">Importar planilha</v-btn>
            <v-btn color="error" class="mb-3 w-100">Exportar planilha</v-btn>
            <v-btn color="primary" class="mb-3 w-100">Novo dado</v-btn>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            @click="dialogProducaoDiaria = false"
          >
            Fechar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogProducaoInstantanea"
      persistent
      max-width="800px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="9">
            Produção instantânea da <b>Usina Luciano</b>
          </v-col>
          <v-col cols="3" class="text-right">
            <v-icon @click="dialogProducaoInstantanea = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-row align="center">
          <v-col cols="12" sm="9" md="9" lg="9" xl="9" class="pt-0">
            <v-simple-table class="base_table" fixed-header height="400px">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      ID
                    </th>
                    <th class="text-center">
                      Data
                    </th>
                    <th class="text-center">
                      Produção
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(index) in 10" :key="index">
                    <td class="text-left">{{index+1}}</td>
                    <td class="text-center">21/07/2022 às 18:59:46</td>
                    <td class="text-center">49,6</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col cols="12" sm="3" md="3" lg="3" xl="3" class="pt-0 text-center">
            <v-btn color="success" class="mb-3 w-100">Importar planilha</v-btn>
            <v-btn color="error" class="mb-3 w-100">Exportar planilha</v-btn>
            <v-btn color="primary" class="mb-3 w-100">Novo dado</v-btn>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            @click="dialogProducaoInstantanea = false"
          >
            Fechar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog> -->
    <v-dialog
      v-model="dialogProducaoDiaria"
      persistent
      max-width="800px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="8">
            Produção diária de {{usina.usi_nome ? usina.usi_nome : 'Usina'}}
          </v-col>
          <v-col cols="4" class="text-right">
            <v-row no-gutters align="center" justify="end">
              <v-btn @click="openNovaProducaoDiaria()" color="primary" class="mr-3" v-if="!isIntegrador() || $root.Permissions.validate(['usinas:producao-diaria:visualizar'])">Nova produção</v-btn>
              <v-icon @click="closeProducaoDiaria()">close</v-icon>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-tabs
          next-icon="chevron_right"
          prev-icon="chevron_left"
          slider-color="primary"
          show-arrows
          v-model="tabProducaoDiaria">
          <v-tab
            :disabled="carregandoProducaoDiaria"
          >
            Usina
          </v-tab>
          <v-tab :disabled="loadingInversoresProducaoDiaria">
            Inversores
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabProducaoDiaria">
          <v-tab-item>
            <v-data-table
              :headers="headersProducaoDiaria"
              :items="dadosProducaoDiaria"
              :search="searchProducaoDiaria"
              :loading="carregandoProducaoDiaria"
              loading-text="Carregando... Por favor aguarde"
              multi-sort
              fixed-header
              height="400px"
              class="elevation-1 base_table"
              :footer-props="{
                itemsPerPageOptions: [5,10,15,20,25,50,100],
                showFirstLastPage: true,
                firstIcon: 'skip_previous',
                lastIcon: 'skip_next',
                prevIcon: 'chevron_left',
                nextIcon: 'chevron_right'
              }"
              :header-props="{
                sortIcon: 'north',
              }"
            >
              <template v-slot:top>
                <v-row no-gutters align="center" justify="space-between">
                  <div class="py-2 px-2 table_search_area">
                    <VueCtkDateTimePicker
                      v-on:callback="changeDatesProducaoDiaria"
                      v-model="data_entrada_producao_diaria"
                      class="date-picker"
                      locale="pt-BR"
                      :no-header="true"
                      :no-value-to-custom-elem="true"
                      :overlay="true"
                      :range="true"
                      :formatted="'L'"
                      :format="'YYYY-MM-DD'"
                      color="#EC6521"
                      :dark="$vuetify.theme.dark"
                      button-color="#EC6521"
                      :custom-shortcuts="labels"
                      :no-button="true"
                      :noClearButton="true"
                      :auto-close="true"
                      :loading="carregandoProducaoDiaria"
                      :disabled="carregandoProducaoDiaria"
                      :submit="retornoDataProducaoDiaria()"
                    >
                      <v-btn class="px-2 py-1 ui-search_data" elevation="0" v-ripple="{ class: `success--text` }">
                        <b class="text text-primary">
                          Período: {{ formatDateFront(de, 'LL')}} - {{formatDateFront(ate, 'LL') }}
                        </b>
                      </v-btn>
                    </VueCtkDateTimePicker>
                  </div>
                  <!-- <div class="py-2 px-2 table_search_area">
                    <v-text-field
                      clearable
                      hide-details=""
                      clear-icon="close"
                      v-model="searchProducaoInstantanea"
                      outlined
                      label="Busca"
                    ></v-text-field>
                  </div> -->
                  <!-- <div>
                    <v-menu
                      bottom
                      center
                      offset-y
                      max-height="400"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                          Exportar
                          <v-icon>arrow_drop_down</v-icon>
                        </div>
                      </template>
                      <v-list>
                        <v-list-item @click="''">
                          <v-list-item-icon class="mr-1">
                            <v-icon color="primary">receipt_long</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>Exportar para XLS</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="''">
                          <v-list-item-icon class="mr-1">
                            <v-icon color="primary">assignment</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>Exportar para TXT</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div> -->
                </v-row>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-row no-gutters align="center" justify="center" v-if="!isIntegrador() || $root.Permissions.validate(['usinas:producao-diaria:visualizar'])" >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click="openNovaProducaoDiaria(item)" color="primary" class="mr-2">
                        edit
                      </v-icon>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click="opendialogDeleteProducaoDiaria(item)" color="primary" class="ml-2">
                        delete
                      </v-icon>
                    </template>
                    <span>Excluir</span>
                  </v-tooltip>
                </v-row>
              </template>
            </v-data-table>
          </v-tab-item>
          <v-tab-item>
            <v-data-table
              :headers="headersProducaoDiariaInversor"
              :items="dadosProducaoDiariaInversor"
              :search="searchProducaoDiaria"
              :loading="carregandoProducaoDiariaInversor"
              loading-text="Carregando... Por favor aguarde"
              multi-sort
              fixed-header
              height="400px"
              class="elevation-1 base_table"
              :footer-props="{
                itemsPerPageOptions: [5,10,15,20,25,50,100],
                showFirstLastPage: true,
                firstIcon: 'skip_previous',
                lastIcon: 'skip_next',
                prevIcon: 'chevron_left',
                nextIcon: 'chevron_right'
              }"
              :header-props="{
                sortIcon: 'north',
              }"
            >
              <template v-slot:top>
                <v-row no-gutters align="start" justify="space-between">
                  <div class="py-2 px-2 table_search_area">
                    <VueCtkDateTimePicker
                      v-on:callback="changeDatesProducaoDiariaInversor"
                      v-model="data_entrada_producao_diaria_inversor"
                      class="date-picker"
                      locale="pt-BR"
                      :no-header="true"
                      :no-value-to-custom-elem="true"
                      :overlay="true"
                      :range="true"
                      :formatted="'L'"
                      :format="'YYYY-MM-DD'"
                      color="#EC6521"
                      :dark="$vuetify.theme.dark"
                      button-color="#EC6521"
                      :custom-shortcuts="labels"
                      :no-button="true"
                      :noClearButton="true"
                      :auto-close="true"
                      :loading="carregandoProducaoDiariaInversor"
                      :disabled="carregandoProducaoDiariaInversor"
                      :submit="retornoDataProducaoDiariaInversor()"
                    >
                      <v-btn class="px-2 py-1 ui-search_data" elevation="0" v-ripple="{ class: `success--text` }">
                        <b class="text text-primary">
                          Período: {{ formatDateFront(de, 'LL')}} - {{formatDateFront(ate, 'LL') }}
                        </b>
                      </v-btn>
                    </VueCtkDateTimePicker>
                  </div>
                  <div class="py-2 px-2 table_search_area">
                    <v-autocomplete
                      :menu-props="{ offsetY: true}"
                      v-model="inversorSelect"
                      :items="inversoresProducaoDiaria"
                      clearable
                      clear-icon="close"
                      label="Inversor"
                      :rules="[rules.required]"
                      @change="getProducaoDiariaInversor(inversorSelect)"
                      append-icon="expand_more"
                      :loading="salvando || loadingInversoresProducaoDiaria"
                      :disabled="salvando || loadingInversoresProducaoDiaria"
                      outlined
                    >
                    </v-autocomplete>
                  </div>
                </v-row>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-row no-gutters align="center" justify="center" v-if="!isIntegrador() || $root.Permissions.validate(['usinas:producao-diaria:visualizar'])" >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click="openNovaProducaoDiaria(item)" color="primary" class="mr-2">
                        edit
                      </v-icon>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click="opendialogDeleteProducaoDiaria(item)" color="primary" class="ml-2">
                        delete
                      </v-icon>
                    </template>
                    <span>Excluir</span>
                  </v-tooltip>
                </v-row>
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs-items>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            @click="closeProducaoDiaria()"
          >
            Fechar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluirProducaoDiaria" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Produção diária
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelDialogDeleteProducaoDiaria()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Produção Diária <b class="text-primary">{{producaoDiaria ? producaoDiaria.upr_id : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="cancelDialogDeleteProducaoDiaria()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeProducaoDiaria()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogNovaProducaoDiaria"
      persistent
      max-width="400px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{producaoDiaria.uuid_upr_id ? 'Editar' : 'Nova'}} produção diária
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogProducaoDiaria()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formProducaoDiaria">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
              <v-menu
                ref="calendarDataProducaoDiaria"
                v-model="calendarDataProducaoDiaria"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    label="Data*"
                    :rules="[rules.required]"
                    append-icon="calendar_today"
                    :loading="salvando"
                    :disabled="salvando"
                    v-bind="attrs"
                    v-on="on"
                    v-model="dataFormatadaProducaoDiaria"
                    v-mask="'##/##/####'"
                    @input="() => {
                      calendarDataProducaoDiaria = false
                      producaoDiaria.upr_data = $root.Formatter.parseDate(dataFormatadaProducaoDiaria)
                      updatePickerModalDataProducaoDiaria = $root.Formatter.parseDate(dataFormatadaProducaoDiaria)
                    }"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :picker-date.sync="updatePickerModalDataProducaoDiaria"
                  year-icon="calendar_today"
                  prev-icon="chevron_left"
                  next-icon="chevron_right"
                  :loading="salvando"
                  :disabled="salvando"
                  v-model="dataProducaoDiaria"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <!-- <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
              <v-text-field
                v-model="indicador.uin_hora"
                label="Hora*"
                :rules="[rules.required]"
                autofocus
                type="time"
                outlined
                v-mask="'##:##'"
              ></v-text-field>
            </v-col> -->
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
              <v-text-field-percent
                label="Produção*"
                :disabled="salvando"
                :rules="[rules.required]"
                :loading="salvando"
                outlined
                v-model="producaoDiaria.upr_producao"
                v-bind:properties="{
                  suffix: '',
                  readonly: false,
                  disabled: false,
                  outlined: true,
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 4,
                  precision: 2,
                  empty: 0,
                }"
              ></v-text-field-percent>
            </v-col>
          </v-row>
        </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="closeDialogProducaoDiaria()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditProducaoDiaria()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <!--Prod instantanea-->
    <v-dialog
      v-model="dialogProducaoInstantanea"
      persistent
      max-width="800px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="8">
            Produção instantânia da {{usina.usi_nome ? usina.usi_nome : 'Usina'}}
          </v-col>
          <v-col cols="4" class="text-right" >
            <v-row no-gutters align="center" justify="end">
              <v-btn @click="openNovaProducaoInstantanea()" color="primary" class="mr-3" v-if="!isIntegrador() || $root.Permissions.validate(['usinas:producao-instantanea:visualizar'])">Nova produção</v-btn>
              <v-icon @click="closeProdInst()">close</v-icon>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-tabs
          next-icon="chevron_right"
          prev-icon="chevron_left"
          slider-color="primary"
          show-arrows
          v-model="tabProducaoInstantanea">
          <v-tab
            :disabled="carregandoProducaoDiaria"
          >
            Usina
          </v-tab>
          <v-tab :disabled="loadingInversoresProducaoDiaria">
            Inversores
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabProducaoInstantanea">
          <v-tab-item>
            <v-data-table
              :headers="headersProducaoInstantanea"
              :items="dadosProducaoInstantanea"
              :search="searchProducaoInstantanea"
              :loading="carregandoProducaoInstantanea"
              loading-text="Carregando... Por favor aguarde"
              multi-sort
              fixed-header
              height="400px"
              class="elevation-1 base_table"
              :footer-props="{
                itemsPerPageOptions: [5,10,15,20,25,50,100],
                showFirstLastPage: true,
                firstIcon: 'skip_previous',
                lastIcon: 'skip_next',
                prevIcon: 'chevron_left',
                nextIcon: 'chevron_right'
              }"
              :header-props="{
                sortIcon: 'north',
              }"
            >
          <template v-slot:top>
            <v-row no-gutters align="center" justify="space-between">
              <div class="py-2 px-2 table_search_area">
                <VueCtkDateTimePicker
                  v-on:callback="changeDates"
                  v-model="data_entrada"
                  class="date-picker"
                  locale="pt-BR"
                  :no-header="true"
                  :no-value-to-custom-elem="true"
                  :overlay="true"
                  :range="true"
                  :formatted="'L'"
                  :format="'YYYY-MM-DD'"
                  color="#EC6521"
                  :dark="$vuetify.theme.dark"
                  button-color="#EC6521"
                  :custom-shortcuts="labels"
                  :no-button="true"
                  :noClearButton="true"
                  :auto-close="true"
                  :loading="loadingSearch"
                  :disabled="loadingSearch"
                  :submit="retornoData()"
                >
                  <v-btn class="px-2 py-1 ui-search_data" elevation="0" v-ripple="{ class: `success--text` }">
                    <b class="text text-primary">
                      Período: {{ formatDateFront(de, 'LL')}} - {{formatDateFront(ate, 'LL') }}
                    </b>
                  </v-btn>
                </VueCtkDateTimePicker>
              </div>
              <div class="py-2 px-2 table_search_area">
                <v-text-field
                  clearable
                  hide-details=""
                  clear-icon="close"
                  v-model="searchProducaoInstantanea"
                  outlined
                  label="Busca"
                ></v-text-field>
              </div>
              <!-- <div>
                <v-menu
                  bottom
                  center
                  offset-y
                  max-height="400"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      Exportar
                      <v-icon>arrow_drop_down</v-icon>
                    </div>
                  </template>
                  <v-list>
                    <v-list-item @click="''">
                      <v-list-item-icon class="mr-1">
                        <v-icon color="primary">receipt_long</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Exportar para XLS</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="''">
                      <v-list-item-icon class="mr-1">
                        <v-icon color="primary">assignment</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Exportar para TXT</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div> -->
            </v-row>
          </template>
          <template v-slot:item.upr_hora="{ item }">
            {{item.upr_hora | VMask('##:##')}}
          </template>
          <template v-slot:item.actions="{ item }" v-if="!isIntegrador() || $root.Permissions.validate(['usinas:producao-instantanea:visualizar'])" >
            <v-row no-gutters align="center" justify="center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" @click="openNovaProducaoInstantanea(item)" color="primary" class="mr-2">
                    edit
                  </v-icon>
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" @click="opendialogDeleteProducaoInstantanea(item)" color="primary" class="ml-2">
                    delete
                  </v-icon>
                </template>
                <span>Excluir</span>
              </v-tooltip>
            </v-row>
          </template>
            </v-data-table>
          </v-tab-item>
          <!-- INVERSORES -->
          <v-tab-item>
            <v-data-table
              :headers="headersProducaoInstantaneaInversor"
              :items="dadosProducaoInstantaneaInversor"
              :search="searchProducaoInstantanea"
              :loading="carregandoProducaoInstantaneaInversor"
              loading-text="Carregando... Por favor aguarde"
              multi-sort
              fixed-header
              height="400px"
              class="elevation-1 base_table"
              :footer-props="{
                itemsPerPageOptions: [5,10,15,20,25,50,100],
                showFirstLastPage: true,
                firstIcon: 'skip_previous',
                lastIcon: 'skip_next',
                prevIcon: 'chevron_left',
                nextIcon: 'chevron_right'
              }"
              :header-props="{
                sortIcon: 'north',
              }"
            >
              <template v-slot:top>
                <v-row no-gutters align="center" justify="space-between">
                  <div class="py-2 px-2 table_search_area">
                    <VueCtkDateTimePicker
                      v-on:callback="changeDatesInversor"
                      v-model="data_entrada_inversor"
                      class="date-picker"
                      locale="pt-BR"
                      :no-header="true"
                      :no-value-to-custom-elem="true"
                      :overlay="true"
                      :range="true"
                      :formatted="'L'"
                      :format="'YYYY-MM-DD'"
                      color="#EC6521"
                      :dark="$vuetify.theme.dark"
                      button-color="#EC6521"
                      :custom-shortcuts="labels"
                      :no-button="true"
                      :noClearButton="true"
                      :auto-close="true"
                      :loading="loadingSearch"
                      :disabled="loadingSearch"
                      :submit="retornoDataInversor()"
                    >
                      <v-btn class="px-2 py-1 ui-search_data" elevation="0" v-ripple="{ class: `success--text` }">
                        <b class="text text-primary">
                          Período: {{ formatDateFront(de_inversor, 'LL')}} - {{formatDateFront(ate_inversor, 'LL') }}
                        </b>
                      </v-btn>
                    </VueCtkDateTimePicker>
                  </div>
                  <div class="py-2 px-2 mt-5 table_search_area">
                    <v-autocomplete
                      :menu-props="{ offsetY: true}"
                      v-model="inversorSelect"
                      :items="inversoresProducaoDiaria"
                      clearable
                      clear-icon="close"
                      @click:clear="limpaDadosInversor()"
                      label="Inversor"
                      @change="getProducaoInstantaneaInversor(inversorSelect)"
                      append-icon="expand_more"
                      :loading="salvando || loadingInversoresProducaoDiaria"
                      :disabled="salvando || loadingInversoresProducaoDiaria"
                      outlined
                    >
                    </v-autocomplete>
                  </div>
                </v-row>
              </template>
              <template v-slot:item.upr_hora="{ item }">
                {{item.upr_hora | VMask('##:##')}}
              </template>
              <template v-slot:item.actions="{ item }" v-if="!isIntegrador() || $root.Permissions.validate(['usinas:producao-instantanea:visualizar'])">
                <v-row no-gutters align="center" justify="center" >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click="openNovaProducaoInstantanea(item)" color="primary" class="mr-2">
                        edit
                      </v-icon>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click="opendialogDeleteProducaoInstantanea(item)" color="primary" class="ml-2">
                        delete
                      </v-icon>
                    </template>
                    <span>Excluir</span>
                  </v-tooltip>
                </v-row>
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs-items>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            @click="closeProdInst()"
          >
            Fechar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluirProducaoInstantanea" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Produção instantânea
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelDialogDeleteProducaoInstantanea()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Produção Instantânea <b class="text-primary">{{producaoInstantanea ? producaoInstantanea.upr_id : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="cancelDialogDeleteProducaoInstantanea()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeProducaoInstantanea()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogNovaProducaoInstantanea"
      persistent
      max-width="400px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{producaoInstantanea.uuid_upr_id ? 'Editar' : 'Nova'}} produção instantânea
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogProducaoInstantanea()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formProducaoInstantanea">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
              <v-autocomplete
                class="pb-0"
                :rules="[rules.required]"
                :menu-props="{ offsetY: true}"
                v-model="producaoInstantanea.uuid_inv_id"
                :items="inversoresProducaoDiaria"
                clearable
                clear-icon="close"
                label="Inversor"
                append-icon="expand_more"
                :loading="salvando || loadingInversoresProducaoDiaria"
                :disabled="salvando || loadingInversoresProducaoDiaria"
                outlined
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
              <v-menu
                ref="calendarDataProducaoInstantanea"
                v-model="calendarDataProducaoInstantanea"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    label="Data*"
                    :rules="[rules.required]"
                    append-icon="calendar_today"
                    :loading="salvando"
                    :disabled="salvando"
                    v-bind="attrs"
                    v-on="on"
                    v-model="dataFormatadaProducaoInstantanea"
                    v-mask="'##/##/####'"
                    @input="() => {
                      calendarDataProducaoInstantanea = false
                      producaoInstantanea.upr_data = $root.Formatter.parseDate(dataFormatadaProducaoInstantanea)
                      updatePickerModalDataProducaoInstantanea = $root.Formatter.parseDate(dataFormatadaProducaoInstantanea)
                    }"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :picker-date.sync="updatePickerModalDataProducaoInstantanea"
                  year-icon="calendar_today"
                  prev-icon="chevron_left"
                  next-icon="chevron_right"
                  :loading="salvando"
                  :disabled="salvando"
                  v-model="dataProducaoInstantanea"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
              <v-text-field
                v-model="producaoInstantanea.upr_hora"
                label="Hora*"
                :rules="[rules.required]"
                type="time"
                outlined
                v-mask="'##:##'"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
              <v-text-field-percent
                label="Produção*"
                :disabled="salvando"
                :rules="[rules.required]"
                :loading="salvando"
                outlined
                v-model="producaoInstantanea.upr_producao"
                v-bind:properties="{
                  suffix: '',
                  readonly: false,
                  disabled: false,
                  outlined: true,
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 4,
                  precision: 2,
                  empty: 0,
                }"
              ></v-text-field-percent>
            </v-col>
          </v-row>
        </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="closeDialogProducaoInstantanea()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditProducaoInstantanea()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogIndicadores"
      persistent
      max-width="1000px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="9">
            Indicadores
          </v-col>
          <v-col cols="3" class="text-right">
            <v-row no-gutters align="center" justify="end">
              <v-btn @click="dialogNovoIndicador = true" color="primary" class="mr-3" v-if="!isIntegrador() || $root.Permissions.validate(['usinas:indicadores:visualizar'])">Novo indicador</v-btn>
              <v-icon @click="dialogIndicadores = false">close</v-icon>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-data-table
          :headers="headersIndicadores"
          :items="dadosIndicadores"
          :search="searchIndicadores"
          :loading="carregandoIndicadores"
          loading-text="Carregando... Por favor aguarde"
          multi-sort
          fixed-header
          height="400px"
          class="elevation-1 base_table"
          :footer-props="{
            itemsPerPageOptions: [5,10,15,20,25,50,100],
            showFirstLastPage: true,
            firstIcon: 'skip_previous',
            lastIcon: 'skip_next',
            prevIcon: 'chevron_left',
            nextIcon: 'chevron_right'
          }"
          :header-props="{
            sortIcon: 'north',
          }"
        >
          <template v-slot:top>
            <v-row no-gutters align="center" justify="space-between">
              <div class="py-2 px-2 table_search_area">
                <v-text-field
                  clearable
                  hide-details=""
                  clear-icon="close"
                  v-model="searchIndicadores"
                  outlined
                  label="Busca"
                ></v-text-field>
              </div>
              <!-- <div>
                <v-menu
                  bottom
                  center
                  offset-y
                  max-height="400"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      Exportar
                      <v-icon>arrow_drop_down</v-icon>
                    </div>
                  </template>
                  <v-list>
                    <v-list-item @click="''">
                      <v-list-item-icon class="mr-1">
                        <v-icon color="primary">receipt_long</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Exportar para XLS</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="''">
                      <v-list-item-icon class="mr-1">
                        <v-icon color="primary">assignment</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Exportar para TXT</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div> -->
            </v-row>
          </template>
          <template v-slot:item.uin_hora="{ item }">
            {{item.uin_hora | VMask('##:##')}}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-row no-gutters align="center" justify="center" v-if="!isIntegrador() || $root.Permissions.validate(['usinas:indicadores:visualizar'])">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" @click="openNovoIndicador(item)" color="primary" class="mr-2">
                    edit
                  </v-icon>
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" @click="opendialogDeleteIndicador(item)" color="primary" class="ml-2">
                    delete
                  </v-icon>
                </template>
                <span>Excluir</span>
              </v-tooltip>
            </v-row>
          </template>
        </v-data-table>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            @click="dialogIndicadores = false"
          >
            Fechar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluirIndicador" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Indicador
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelDialogDeleteIndicador()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Indicador <b class="text-primary">{{indicador ? indicador.uin_id : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="cancelDialogDeleteIndicador()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeIndicador()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogNovoIndicador"
      persistent
      max-width="400px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{indicador.uuid_uin_id ? 'Editar' : 'Novo'}} Indicador
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogIndicadores()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formIndicador">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
              <v-menu
                ref="calendarDataIndicador"
                v-model="calendarDataIndicador"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    label="Data*"
                    :rules="[rules.required]"
                    append-icon="calendar_today"
                    :loading="salvando"
                    :disabled="salvando"
                    v-bind="attrs"
                    v-on="on"
                    v-model="dataFormatadaIndicador"
                    v-mask="'##/##/####'"
                    @input="() => {
                      calendarDataIndicador = false
                      indicador.uin_data = $root.Formatter.parseDate(dataFormatadaIndicador)
                      updatePickerModalDataIndicador = $root.Formatter.parseDate(dataFormatadaIndicador)
                    }"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :picker-date.sync="updatePickerModalDataIndicador"
                  year-icon="calendar_today"
                  prev-icon="chevron_left"
                  next-icon="chevron_right"
                  :loading="salvando"
                  :disabled="salvando"
                  v-model="dataIndicador"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
              <v-text-field
                v-model="indicador.uin_hora"
                label="Hora*"
                :rules="[rules.required]"
                autofocus
                type="time"
                outlined
                v-mask="'##:##'"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
              <v-text-field
                v-model="indicador.uin_campo"
                label="Campo*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
              <v-text-field
                v-model="indicador.uin_valor"
                label="Valor*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="closeDialogIndicadores()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditIndicador()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogOcorrencias"
      persistent
      max-width="1000px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="9">
            Ocorrências da usina {{usina.usi_nome}}
          </v-col>
          <v-col cols="3" class="text-right">
            <v-row no-gutters align="center" justify="end">
              <v-btn @click="dialogNovaOcorrencia = true" color="primary" class="mr-3" v-if="!isIntegrador() || $root.Permissions.validate(['usinas:ocorrencias:visualizar'])">Nova Ocorrência</v-btn>
              <v-icon @click="dialogOcorrencias = false">close</v-icon>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div>
          <v-data-table
            :headers="headersOcorrencias"
            :items="dadosOcorrencias"
            :search="searchOcorrencias"
            multi-sort
            :loading="loadingOcorrencias"
            loading-text="Carregando... Por favor aguarde"
            fixed-header
            height="400px"
            class="elevation-1 base_table"
            :footer-props="{
              itemsPerPageOptions: [5,10,15,20,25,50,100],
              showFirstLastPage: true,
              firstIcon: 'skip_previous',
              lastIcon: 'skip_next',
              prevIcon: 'chevron_left',
              nextIcon: 'chevron_right'
            }"
            :header-props="{
              sortIcon: 'north',
            }"
          >
            <template v-slot:top>
              <v-row no-gutters align="center" justify="space-between">
                <div class="py-2 px-2 table_search_area">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="searchOcorrencias"
                    outlined
                    label="Busca"
                  ></v-text-field>
                </div>
                <!-- <div>
                  <v-menu
                    bottom
                    center
                    offset-y
                    max-height="400"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        Exportar
                        <v-icon>arrow_drop_down</v-icon>
                      </div>
                    </template>
                    <v-list>
                      <v-list-item @click="''">
                        <v-list-item-icon class="mr-1">
                          <v-icon color="primary">receipt_long</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Exportar para XLS</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="''">
                        <v-list-item-icon class="mr-1">
                          <v-icon color="primary">assignment</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Exportar para TXT</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div> -->
              </v-row>
            </template>
            <template v-slot:item.actions="{ item }" v-if="!isIntegrador() || $root.Permissions.validate(['usinas:ocorrencias:visualizar'])">
              <v-row no-gutters align="center" justify="center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="openNovaOcorrencia(item)" color="primary" class="mr-2">
                      edit
                    </v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="openDialogDeleteOcorrencia(item)" color="primary" class="ml-2">
                      delete
                    </v-icon>
                  </template>
                  <span>Excluir</span>
                </v-tooltip>
              </v-row>
            </template>
            <template v-slot:item.arquivo="{ item }">
              <div v-if="item.uso_arquivo">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <a :href="item.uso_arquivo" v-bind="attrs" v-on="on" target="_blank">
                      <v-icon color="primary">file_open</v-icon>
                    </a>
                  </template>
                  <span>Visualizar arquivo</span>
                </v-tooltip>
              </div>
              <div v-else class="pl-3">
                -
              </div>
            </template>
          </v-data-table>
        </div>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            @click="dialogOcorrencias = false"
          >
            Fechar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluirOcorrencia" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Ocorrência
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelDialogDeleteOcorrencia()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Ocorrência <b class="text-primary">{{ocorrencia ? ocorrencia.uso_nome : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="cancelDialogDeleteOcorrencia()"
          >
            Cancelar
          </v-btn>
          <v-btn
            :loading="salvando"
            :disabled="salvando"
            color="success"
            @click="removeOcorrencia()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogNovaOcorrencia"
      persistent
      max-width="500px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{ocorrencia.uuid_uso_id ? 'Editar' : 'Nova'}} Ocorrência
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogOcorrencia()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formOcorrencia">
          <v-row>
            <v-col cols="6" sm="6" md="6" lg="6" xl="6" class="pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="ocorrencia.uso_tipo"
                :items="dadosUsinasOcorrencias"
                clearable
                clear-icon="close"
                label="Categoria*"
                :rules="[rules.required]"
                append-icon="expand_more"
                :loading="salvando"
                :disabled="salvando"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="6" sm="6" md="6" lg="6" xl="6" class="pb-0">
              <v-text-field
                v-model="ocorrencia.uso_nome"
                label="Nome*"
                :rules="[rules.required]"
                autofocus
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-menu
                ref="calendarDataOcorrencia"
                v-model="calendarDataOcorrencia"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    label="Data*"
                    :rules="[rules.required]"
                    append-icon="calendar_today"
                    :loading="salvando"
                    :disabled="salvando"
                    v-bind="attrs"
                    v-on="on"
                    v-model="dataFormatadaOcorrencia"
                    v-mask="'##/##/####'"
                    @input="() => {
                      calendarDataOcorrencia = false
                      ocorrencia.uso_data = $root.Formatter.parseDate(dataFormatadaOcorrencia)
                      updatePickerModalDataOcorrencia = $root.Formatter.parseDate(dataFormatadaOcorrencia)
                    }"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :picker-date.sync="updatePickerModalDataOcorrencia"
                  year-icon="calendar_today"
                  prev-icon="chevron_left"
                  next-icon="chevron_right"
                  :loading="salvando"
                  :disabled="salvando"
                  v-model="dataOcorrencia"
                ></v-date-picker>
              </v-menu>
            </v-col>
           <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field
                v-model="ocorrencia.uso_hora"
                label="Hora*"
                :rules="[rules.required]"
                type="time"
                outlined
                v-mask="'##:##'"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 pb-0">
              <v-textarea
                outlined
                no-resize
                rows="3"
                v-model="ocorrencia.uso_descricao"
                label="Descrição"
                :disabled="salvando"
                :loading="salvando"
              ></v-textarea>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0">
              <v-file-input
                show-size
                clearable
                ref="file"
                v-model="ocorrencia.uso_arquivo"
                prepend-icon="description"
                label="Adicionar arquivo"
                clear-icon="close"
                truncate-length="50"
                :loading="salvando"
                :disabled="salvando"
                v-if="isObject(ocorrencia.uso_arquivo)"
                outlined
              ></v-file-input>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 mb-6" v-if="ocorrencia.uso_arquivo && !isObject(ocorrencia.uso_arquivo)">
              <v-row no-gutters justify="space-between" align="center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <a :href="ocorrencia.uso_arquivo" v-bind="attrs" v-on="on" target="_blank">Arquivo: <v-icon color="primary">file_open</v-icon></a>
                  </template>
                  <span>Visualizar arquivo</span>
                </v-tooltip>
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="dialogDeletarArquivoOcorrencia = true" v-bind="attrs" v-on="on" color="primary">delete</v-icon>
                    </template>
                    <span>Remover arquivo</span>
                  </v-tooltip>
                </div>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="closeDialogOcorrencia()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditOcorrencia()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeletarArquivoOcorrencia" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover Arquivo
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogDeletarArquivoOcorrencia = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja remover este arquivo?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogDeletarArquivoOcorrencia = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeArquivoOcorrencia()"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogImportacao"
      persistent
      max-width="600px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Importar Usinas
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogImportacao()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formImportacao">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 pb-0">
              <v-autocomplete
                autofocus
                autocomplete="off"
                v-model="importacao.interface"
                :items="interfaceEnum"
                :loading="importacaoLoading"
                :disabled="importacaoLoading"
                :rules="[rules.required]"
                label="Interface"
                append-icon="expand_more"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field
                v-model="importacao.userName"
                label="Usuário*"
                :rules="[rules.required]"
                type="text"
                outlined
                :disabled="importacaoLoading"
                :loading="importacaoLoading"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field
                @click:append="showImportacaoPassword = !showImportacaoPassword"
                :type="showImportacaoPassword ? 'text' : 'password'"
                :append-icon="showImportacaoPassword ? 'remove_red_eye' : 'visibility_off'"
                v-model="importacao.password"
                outlined
                :rules="[rules.required]"
                label="Senha*"
                :disabled="importacaoLoading"
                :loading="importacaoLoading"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="importacao.interface === 'SOLARMAN'">
            <v-col cols="12" sm="6" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                v-model="importacao.appSecret"
                outlined
                label="App Secret*"
                type="text"
                :rules="importacao.interface === 'SOLARMAN' && [rules.required]"
                :disabled="importacaoLoading"
                :loading="importacaoLoading"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                v-model="importacao.appId"
                outlined
                label="App ID*"
                type="text"
                :rules="importacao.interface === 'SOLARMAN' && [rules.required]"
                :disabled="importacaoLoading"
                :loading="importacaoLoading"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                v-model="importacao.orgId"
                outlined
                label="Org ID*"
                type="text"
                :rules="importacao.interface === 'SOLARMAN' && [rules.required]"
                :disabled="importacaoLoading"
                :loading="importacaoLoading"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
                :disabled="importacaoLoading"
                :loading="importacaoLoading"
            @click="closeDialogImportacao()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="importUsinas()"
            :disabled="importacaoLoading"
            :loading="importacaoLoading"
          >
            Importar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
import axios from 'axios'
import moment from 'moment'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import RelatorioBase from '@components/impressoes/RelatorioBase.vue'
import _debounce from 'lodash.debounce'
export default {
  components: {
    VueCtkDateTimePicker
  },
  data () {
    return {
      userInfo: null,
      carregando: false,
      total: 0,
      options: {},
      data_entrada: {
        start: moment().startOf('month').format('YYYY-MM-DD'),
        end: moment(new Date()).format('YYYY-MM-DD')
      },
      data_entrada_inversor: {
        start: moment().startOf('month').format('YYYY-MM-DD'),
        end: moment(new Date()).format('YYYY-MM-DD')
      },
      data_entrada_producao_diaria: {
        start: moment().startOf('month').format('YYYY-MM-DD'),
        end: moment(new Date()).format('YYYY-MM-DD')
      },
      data_entrada_producao_diaria_inversor: {
        start: moment().startOf('month').format('YYYY-MM-DD'),
        end: moment(new Date()).format('YYYY-MM-DD')
      },
      de: moment().startOf('month').format('YYYY-MM-DD'),
      ate: moment(new Date()).format('YYYY-MM-DD'),
      de_inversor: moment().startOf('month').format('YYYY-MM-DD'),
      ate_inversor: moment(new Date()).format('YYYY-MM-DD'),
      de_producao_diaria: moment().startOf('month').format('YYYY-MM-DD'),
      ate_producao_diaria: moment(new Date()).format('YYYY-MM-DD'),
      de_producao_diaria_inversor: moment().startOf('month').format('YYYY-MM-DD'),
      ate_producao_diaria_inversor: moment(new Date()).format('YYYY-MM-DD'),
      labels: [
        { key: 'thisDay', label: 'Hoje', value: 'day' },
        { key: 'last30Days', label: 'Últimos 30 dias', value: 30 },
        { key: 'thisMonth', label: 'Este mês', value: 'month' },
        { key: 'lastMonth', label: 'Mês passado', value: '-month' },
        { key: 'thisYear', label: 'Este ano', value: 'year' },
        { key: 'lastYear', label: 'Último ano', value: '-year' }
      ],
      loadingSearch: false,
      user: '',
      tabProducaoDiaria: 0,
      loadingInversoresProducaoDiaria: false,
      inversoresProducaoDiaria: [],
      loading: true,
      salvando: false,
      dialogNovo: false,
      dialogUsina: false,
      dialogCreditos: false,
      dialogExcluir: false,
      dialogExcluirCredito: false,
      dialogNovoCredito: false,
      dialogInversor: false,
      dialogNovoInversor: false,
      dialogExcluirInversor: false,
      dialogExcluirInversorAdicionado: false,
      dialogProducaoDiaria: false,
      dialogProducaoInstantanea: false,
      keyProdInst: 0,
      dialogIndicadores: false,
      dialogExcluirIndicador: false,
      dialogNovoIndicador: false,
      dialogExcluirProducaoDiaria: false,
      dialogNovaProducaoDiaria: false,
      dialogExcluirProducaoInstantanea: false,
      dialogNovaProducaoInstantanea: false,
      dialogImportacao: false,
      showPassword: false,
      showRepeatPassword: false,
      loadingCep: false,
      estados: [],
      cidades: [],
      cidadesFiltradas: [],
      loadingEstados: false,
      loadingCidades: false,
      calendarData: false,
      dataDesativada: '',
      dataFormatadaDesativada: '',
      updatePickerModalDataDesativada: '',
      dataInstalacao: '',
      dataFormatadaInstalacao: '',
      updatePickerModalDataInstalacao: '',
      calendarDataInstalacao: false,
      dataIndicador: '',
      dataFormatadaIndicador: '',
      updatePickerModalDataIndicador: '',
      calendarDataIndicador: false,
      dataProducaoDiaria: '',
      dataFormatadaProducaoDiaria: '',
      updatePickerModalDataProducaoDiaria: '',
      calendarDataProducaoDiaria: false,
      dataProducaoInstantanea: '',
      dataFormatadaProducaoInstantanea: '',
      updatePickerModalDataProducaoInstantanea: '',
      calendarDataProducaoInstantanea: false,
      dataGarantia: '',
      dataFormatadaGarantia: '',
      updatePickerModalDataGarantia: '',
      calendarDataGarantia: false,
      dataVigencia: '',
      dataFormatadaVigencia: '',
      updatePickerModalDataVigencia: '',
      calendarDataVigencia: false,
      loadingClientes: false,
      clientes: [],
      loadingIntegradores: false,
      integradores: [],
      integradoresCadastro: [],
      status: [],
      loadingStatus: false,
      loadingInversores: false,
      inversores: [],
      nivelUsuarioApelido: '',
      rules: {
        required: value => !!value || 'Obrigatório.'
      },
      search: '',
      loadingInversorSelecionado: false,
      loadingGeoposition: false,
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'usi_id'
        },
        { text: 'Cliente', value: 'cliente.cli_nome' },
        { text: 'Nome', value: 'usi_nome' },
        { text: 'Integrador', value: 'integrador.int_nome' },
        {
          text: 'Status',
          align: 'center',
          value: 'status.uss_nome'
        },
        {
          text: 'Usinas',
          value: 'tipo_usina',
          align: 'center',
          sortable: false,
          width: 110
        },
        {
          text: 'Sistema de crédito',
          value: 'credito',
          align: 'center',
          sortable: false,
          width: 110
        },
        {
          text: 'Inversores',
          value: 'inversores',
          align: 'center',
          sortable: false,
          width: 110
        },
        {
          text: 'Produção diária',
          value: 'producao_diaria',
          align: 'center',
          sortable: false,
          width: 110
        },
        {
          text: 'Produção instantânea',
          value: 'producao_instantanea',
          align: 'center',
          sortable: false,
          width: 110
        },
        {
          text: 'Indicadores',
          value: 'indicadores',
          align: 'center',
          sortable: false,
          width: 110
        },
        {
          text: 'Ocorrências',
          value: 'ocorrencias',
          align: 'center',
          sortable: false,
          width: 110
        },
        {
          text: 'Ações',
          value: 'acoes',
          align: 'center',
          sortable: false,
          width: 130
        }
      ],
      dados: [],
      searchCreditos: '',
      headersCreditos: [
        {
          text: 'ID',
          align: 'start',
          value: 'usc_id'
        },
        { text: 'Unidade consumidora', value: 'unidade.uco_nome' },
        { text: 'Vigência', value: 'usc_vigencia' },
        { text: 'Percentual', value: 'usc_percentual' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dadosCreditos: [],
      searchInversores: '',
      headersInversores: [
        {
          text: 'ID',
          align: 'start',
          value: 'inu_id'
        },
        { text: 'Marca', value: 'inversor.inv_marca' },
        { text: 'Interface', value: 'inversor.inv_interface', align: 'center' },
        { text: 'Modelo', value: 'inversor.inv_modelo', align: 'center' },
        { text: 'Serial', value: 'inversor.inv_serial', align: 'center' },
        { text: 'Status', value: 'inversor.status.uss_nome' },
        { text: 'Gerador', value: 'inversor.gerador.uge_nome' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dadosInversores: [],
      searchIndicadores: '',
      searchProducaoDiaria: '',
      searchProducaoInstantanea: '',
      loadingUnidades: false,
      unidades: [],
      headersIndicadores: [
        {
          text: 'ID',
          align: 'start',
          value: 'uin_id'
        },
        { text: 'Data', value: 'uin_data' },
        { text: 'Hora', value: 'uin_hora' },
        { text: 'Campo', value: 'uin_campo' },
        { text: 'Valor', value: 'uin_valor' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dadosIndicadores: [],
      headersProducaoDiaria: [
        {
          text: 'ID',
          align: 'start',
          value: 'upr_id'
        },
        { text: 'Data', value: 'upr_data' },
        { text: 'Produção', value: 'upr_producao' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      headersProducaoDiariaInversor: [
        {
          text: 'ID',
          align: 'start',
          value: 'upr_id'
        },
        { text: 'Data', value: 'upr_data' },
        { text: 'Produção', value: 'upr_producao' },
        { text: 'Serial', value: 'inv_serial' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dadosProducaoDiaria: [],
      dadosProducaoDiariaInversor: [],
      headersProducaoInstantanea: [
        {
          text: 'ID',
          align: 'start',
          value: 'id'
        },
        { text: 'Data', value: 'data_producao' },
        { text: 'Hora', value: 'hora_producao' },
        { text: 'Produção', value: 'diferenca' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      headersProducaoInstantaneaInversor: [
        {
          text: 'ID',
          align: 'start',
          value: 'id'
        },
        { text: 'Data', value: 'data_producao' },
        { text: 'Hora', value: 'hora_producao' },
        { text: 'Produção', value: 'diferenca' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dadosProducaoInstantanea: [],
      dadosProducaoInstantaneaInversor: [],
      optionsMoney: {
        locale: 'pt-BR',
        prefix: 'R$',
        suffix: '',
        length: 10,
        precision: 2
      },
      usina_detalhes: {
        usp_potencia: '',
        usp_eficiencia: '',
        usp_data_instalacao: '',
        usp_total_investido: '',
        usp_tarifa_referencia: '',
        rsiSelect: '',
        usp_rsi_jan: '',
        usp_rsi_fev: '',
        usp_rsi_mar: '',
        usp_rsi_abr: '',
        usp_rsi_mai: '',
        usp_rsi_jun: '',
        usp_rsi_jul: '',
        usp_rsi_ago: '',
        usp_rsi_set: '',
        usp_rsi_out: '',
        usp_rsi_nov: '',
        usp_rsi_dez: '',
        uuid_uss_id: ''
      },
      carregandoInversores: false,
      usina: {
        usi_nome: '',
        usi_cep: '',
        usi_uf: '',
        usi_cidade: '',
        usi_bairro: '',
        usi_rua: '',
        usi_numero: '',
        usi_complemento: '',
        usi_latitude: '',
        usi_longitude: '',
        usi_desativada: false,
        usi_desativacao: '',
        uuid_int_id: this.user && this.user.uuid_int_id ? this.user.uuid_int_id : '',
        usi_imagem: '',
        uuid_cli_id: ''
      },
      carregandoIndicadores: false,
      carregandoProducaoDiaria: false,
      carregandoProducaoDiariaInversor: false,
      carregandoProducaoInstantanea: false,
      carregandoProducaoInstantaneaInversor: false,
      carregandoCreditos: false,
      credito: {
        usc_vigencia: '',
        usc_percentual: '',
        uuid_uco_id: ''
      },
      inversorPai: {
        inu_painel_quantidade: '',
        inu_painel_potencia: '',
        inv_status: false,
        inv_garantia: '',
        inversor: {
          inv_marca: '',
          inv_potencia: '',
          inv_modelo: '',
          inv_tipo: '',
          inv_status: '',
          inv_garantia: '',
          uuid_uss_id: '',
          uuid_inv_id: '',
          inv_serial: ''
        }
      },
      tipos: [
        {
          text: 'Monofásico',
          value: 1
        },
        {
          text: 'Bifásico',
          value: 2
        },
        {
          text: 'Trifásico',
          value: 3
        }
      ],
      interfacesSelect: [
        {
          text: 'SolarMaker',
          value: 1,
          searchByInversor: false
        },
        {
          text: 'Renac',
          value: 2,
          searchByInversor: true
        },
        {
          text: 'SolarMan',
          value: 3,
          searchByInversor: false
        }
      ],
      loadingGeradores: false,
      dialogDeletarImagem: false,
      indicador: {
        uin_data: '',
        uin_hora: '',
        uin_campo: '',
        uin_valor: ''
      },
      producaoDiaria: {
        upr_data: '',
        upr_producao: '',
        upr_tipo: 1
      },
      producaoInstantanea: {
        upr_data: '',
        upr_hora: '',
        upr_producao: '',
        upr_tipo: 2
      },
      geradores: [],
      geradoresAdicionados: [],
      inversoresAdicionados: [],
      dialogExcluirGerador: false,
      geradorDetalhe: '',
      geradorDetalheIndex: '',
      inversorSelect: '',
      dialogOcorrencias: false,
      dialogNovaOcorrencia: false,
      searchOcorrencias: '',
      dialogDeletarArquivoOcorrencia: false,
      dataOcorrencia: '',
      dataFormatadaOcorrencia: '',
      updatePickerModalDataOcorrencia: '',
      calendarDataOcorrencia: false,
      loadingOcorrencias: false,
      headersOcorrencias: [
        {
          text: 'ID',
          align: 'start',
          value: 'uso_id'
        },
        { text: 'Nome', value: 'uso_nome' },
        { text: 'Data', value: 'uso_data' },
        { text: 'Hora', value: 'uso_hora' },
        {
          text: 'Arquivo',
          value: 'arquivo',
          align: 'center',
          sortable: false,
          width: 110
        },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dadosOcorrencias: [],
      dialogExcluirOcorrencia: false,
      ocorrencia: {
        uso_data: '',
        uso_hora: '',
        uso_nome: '',
        uso_tipo: '',
        uso_descricao: '',
        uso_arquivo: []
      },
      dadosUsinasOcorrencias: [
        {
          text: 'Manutenção preventiva',
          value: 1
        },
        {
          text: 'Geração',
          value: 2
        },
        {
          text: 'Fatura',
          value: 3
        },
        {
          text: 'Inversor',
          value: 4
        },
        {
          text: 'Concessionária',
          value: 5
        },
        {
          text: 'Comissionamento',
          value: 6
        },
        {
          text: 'Monitoramento',
          value: 7
        },
        {
          text: 'Problema na internet',
          value: 8
        },
        {
          text: 'Visita técnica',
          value: 9
        },
        {
          text: 'Compensação',
          value: 10
        },
        {
          text: 'Manutenção corretiva',
          value: 11
        }
      ],
      selectRSI: [],
      selectRSITotal: [],
      geracaoPrevista: '',
      todosGeradores: [],
      tabProducaoInstantanea: '',
      searchGerador: '',
      searchFinal: null,
      loadingDistribuidores: false,
      distribuidores: [],
      distribuidor: null,
      integrador: null,
      distribuidorAnterior: null,
      interfaceEnum: [
        { text: 'Renac', value: 'RENAC' },
        { text: 'Solarman', value: 'SOLARMAN' }
      ],
      showImportacaoPassword: false,
      importacaoLoading: false,
      importacao: {
        userName: null,
        password: null,
        interface: null,
        appSecret: null,
        appId: null,
        orgId: null
      }
    }
  },
  watch: {
    options: {
      handler () {
        this.getUsinas()
      },
      deep: true
    },
    searchGerador (val) {
      this.serchField = val
    },
    dataDesativada () {
      this.dataFormatadaDesativada = moment(this.dataDesativada).format('L')
      this.usina.data_desativada = this.$root.Formatter.parseDate(this.dataFormatadaDesativada)
      this.calendarData = false
    },
    dataInstalacao () {
      this.dataFormatadaInstalacao = moment(this.dataInstalacao).format('L')
      this.usina_detalhes.usp_data_instalacao = this.$root.Formatter.parseDate(this.dataFormatadaInstalacao)
      this.calendarDataInstalacao = false
    },
    dataIndicador () {
      this.dataFormatadaIndicador = moment(this.dataIndicador).format('L')
      this.indicador.uin_data = this.$root.Formatter.parseDate(this.dataFormatadaIndicador)
      this.calendarDataIndicador = false
    },
    dataVigencia () {
      this.dataFormatadaVigencia = moment(this.dataVigencia).format('L')
      this.credito.usc_vigencia = this.$root.Formatter.parseDate(this.dataFormatadaVigencia)
      this.calendarDataVigencia = false
    },
    dataProducaoDiaria () {
      if (this.dataProducaoDiaria) {
        this.dataFormatadaProducaoDiaria = moment(this.dataProducaoDiaria).format('L')
        this.producaoDiaria.upr_data = this.$root.Formatter.parseDate(this.dataFormatadaProducaoDiaria)
        this.calendarDataProducaoDiaria = false
      }
    },
    dataProducaoInstantanea () {
      if (this.dataProducaoInstantanea) {
        this.dataFormatadaProducaoInstantanea = moment(this.dataProducaoInstantanea).format('L')
        this.producaoInstantanea.upr_data = this.$root.Formatter.parseDate(this.dataFormatadaProducaoInstantanea)
        this.calendarDataProducaoInstantanea = false
      }
    },
    dataGarantia () {
      this.dataFormatadaGarantia = moment(this.dataGarantia).format('L')
      this.inversorPai.inversor.inv_garantia = this.$root.Formatter.parseDate(this.dataFormatadaGarantia)
      this.calendarDataGarantia = false
    },
    dataOcorrencia () {
      this.dataFormatadaOcorrencia = moment(this.dataOcorrencia).format('L')
      this.ocorrencia.uso_data = this.$root.Formatter.parseDate(this.dataFormatadaOcorrencia)
      this.calendarDataOcorrencia = false
    }
  },
  methods: {
    async exportXls () {
      this.loadingXls = true
      Api.post('relatorios', {
        headers: this.someHeader(),
        distribuidor: this.distribuidor,
        integrador: this.integrador,
        busca: this.searchFinal,
        type: 'usinas'
      })
        .then(res => {
          const baseUrl = window.location.origin
          this.downloadXls(baseUrl + '/' + res.data.url)
          this.removeXls(res.data.url)
          this.loadingXls = false
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao fazer o donwload!',
            color: 'error'
          })
        })
    },
    async downloadXls (url) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    removeXls (url) {
      let data = {
        url: url
      }
      Api.post('relatorios/remove-s3', data)
    },
    exportPdf () {
      this.$root.Printer.openDialog(this, {
        titulo: 'Usinas', // Título que aparece centralizado na página e como nome do dialog
        component: RelatorioBase, // componente com o layout a ser impresso
        data: this.dados,
        headers: this.someHeader(), // dados para alimentar o componente, por padrão ele chegará como o props data no componente
        css: `` // Classes css que são adicionados na página de impressão
      })
    },
    someHeader () {
      let cabecalhos = []
      this.headers.map(header => {
        if (
          header.text !== 'ID' &&
          header.text !== 'Ações' &&
          header.text !== 'Usuários' &&
          header.text !== 'Sistema de crédito' &&
          header.text !== 'Inversores' &&
          header.text !== 'Produção diária' &&
          header.text !== 'Produção instantânea' &&
          header.text !== 'Indicadores' &&
          header.text !== 'Usinas' &&
          header.text !== 'Ocorrências'
        ) cabecalhos.push(header)
      })
      return cabecalhos
    },
    closeProdInst () {
      this.tabProducaoInstantanea = ''
      this.dialogProducaoInstantanea = false
      this.dadosProducaoInstantaneaInversor = []
    },
    limpaDadosInversor () {
      this.dadosProducaoInstantaneaInversor = []
    },
    formatDateFront (date, format = 'L') {
      return moment(date).format(format)
    },
    retornoDataProducaoDiaria () {
      if (this.data_entrada_producao_diaria.start !== this.de_producao_diaria || this.data_entrada_producao_diaria.end !== this.ate_producao_diaria) {
        if (this.data_entrada_producao_diaria.end !== null) {
          this.de_producao_diaria = this.data_entrada_producao_diaria.start
          this.ate_producao_diaria = this.data_entrada_producao_diaria.end
          this.getProducaoDiaria()
        }
      }
    },
    changeDatesProducaoDiaria (dates) {
      this.de_producao_diaria = dates.start
      this.ate_producao_diaria = dates.end
    },
    retornoDataProducaoDiariaInversor () {
      if (this.data_entrada_producao_diaria_inversor.start !== this.de_producao_diaria_inversor || this.data_entrada_producao_diaria_inversor.end !== this.ate_producao_diaria_inversor) {
        if (this.data_entrada_producao_diaria_inversor.end !== null) {
          this.de_producao_diaria_inversor = this.data_entrada_producao_diaria_inversor.start
          this.ate_producao_diaria_inversor = this.data_entrada_producao_diaria_inversor.end
          this.getProducaoDiariaInversor()
        }
      }
    },
    changeDatesProducaoDiariaInversor (dates) {
      this.de_producao_diaria_inversor = dates.start
      this.ate_producao_diaria_inversor = dates.end
    },
    retornoDataInversor () {
      if (this.data_entrada_inversor.start !== this.de_inversor || this.data_entrada_inversor.end !== this.ate_inversor) {
        if (this.data_entrada_inversor.end !== null) {
          this.de_inversor = this.data_entrada_inversor.start
          this.ate_inversor = this.data_entrada_inversor.end
          if (this.inversorSelect !== '') {
            this.getProducaoInstantaneaInversor(this.inversorSelect)
          }
        }
      }
    },
    changeDatesInversor (dates) {
      this.de_inversor = dates.start
      this.ate_inversor = dates.end
    },
    retornoData () {
      if (this.data_entrada.start !== this.de || this.data_entrada.end !== this.ate) {
        if (this.data_entrada.end !== null) {
          this.de = this.data_entrada.start
          this.ate = this.data_entrada.end
          this.getProducaoInstantanea()
        }
      }
    },
    changeDates (dates) {
      this.de = dates.start
      this.ate = dates.end
    },
    loadFunctions () {
      let filters = this.$route.query
      if (filters.distribuidor) this.distribuidor = filters.distribuidor
      if (filters.integrador) this.integrador = filters.integrador
      if (filters.busca) {
        this.search = filters.busca
        this.searchFinal = filters.busca
      }
      this.getUser()
      this.getUsinas()
      this.getStatus()
      this.getCidade()
      this.getEstados()
      this.getDistribuidores()
      this.getIntegradores()
      this.loading = false
    },
    isObject (val) {
      if (val) {
        return val instanceof Object
      } else {
        return true
      }
    },
    closeProducaoDiaria () {
      this.tabProducaoDiaria = 0
      this.dialogProducaoDiaria = false
    },
    async getInversoresUsina () {
      this.loadingInversoresProducaoDiaria = true
      console.log(this.usina)
      await Api.get('usinas/' + this.usina.uuid_usi_id + '/inversores')
        .then(res => {
          var arrayInvD = []
          res.data.map(inv => {
            arrayInvD.push({
              'text': inv.inversor.inv_serial ? inv.inversor.inv_serial : inv.inversor.inv_marca ? inv.inversor.inv_marca : inv.inversor.inv_modelo ? inv.inversor.inv_modelo : inv.inversor.inv_serial ? inv.inversor.inv_serial : inv.inversor.inv_id,
              'value': inv.inversor.uuid_inv_id
            })
          })
          this.inversoresProducaoDiaria = arrayInvD
          this.loadingInversoresProducaoDiaria = false
        })
        .catch(err => {
          this.loadingInversoresProducaoDiaria = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os inversores da Usina!',
            color: 'error'
          })
          console.log(err)
        })
    },
    openNovaUsina () {
      this.dialogNovo = true
      if (this.user && this.user.uuid_int_id) {
        this.getClientes(this.user.uuid_int_id)
      }
    },
    getInterfaceNameByValue (value) {
      if (!value) {
        return ''
      }
      return this.interfacesSelect.find(interfaceSelect => interfaceSelect.value === value).text
    },
    addGeradorInversor (uid) {
      const item = this.todosGeradores.filter(res => res.uid === uid)[0]
      if (this.interfacesSelect.find(interfaceSelect => interfaceSelect.text.toUpperCase() === item.interface.toUpperCase()).searchByInversor) {
        this.addInversor(uid)
      } else {
        this.addGerador(uid)
      }
    },
    addInversor (item) {
      const inversor = this.todosGeradores.filter(res => res.uid === item)[0]
      if (this.inversoresAdicionados.filter(inversorAdicionado => {
        return (
          (inversorAdicionado.sn && inversorAdicionado.sn === inversor.sn) ||
          (inversorAdicionado.inversor && inversorAdicionado.inversor.inv_serial === inversor.sn)
        )
      }).length) {
        this.$root.SnackControl.open(this, {
          text: 'Inversor já adicionado na lista!',
          color: 'error'
        })
        return false
      }

      this.inversoresAdicionados.push({
        interface_id: this.interfacesSelect.find(item => item.text.toUpperCase() === inversor.interface.toUpperCase()).value,
        status: inversor.status,
        id: inversor.id,
        sn: inversor.sn,
        model: inversor.model,
        brand: inversor.brand,
        extra: inversor.extra,
        updatedAt: inversor.updatedAt,
        interface: inversor.interface
      })
      this.usina.gerador = ''
    },
    async addGerador (item) {
      let resultadoFiltro = false
      this.geradoresAdicionados.filter((res) => {
        if (res.uid === item) {
          resultadoFiltro = true
        }
      })
      if (resultadoFiltro) {
        this.$root.SnackControl.open(this, {
          text: 'Gerador já adicionado na lista!',
          color: 'error'
        })
        return false
      }
      this.loadingGeradores = true
      let retorno = ''
      retorno = this.todosGeradores.filter((res) => {
        if (res.uid === item) {
          return res
        }
      })
      console.log(retorno[0])
      // this.geradoresAdicionados.push(retorno[0])
      let itens = {
        uge_interface_id: retorno[0].interface === 'SOLARMAKER' ? 1 : retorno[0].interface === 'RENAC' ? 2 : retorno[0].interface === 'SOLARMAN' ? 3 : retorno[0].interface,
        status: {
          uss_nome: retorno[0].status
        },
        uge_integracao_id: retorno[0].id,
        uge_nome: retorno[0].name,
        uge_local: retorno[0].location,
        uge_extras: retorno[0].extra,
        uge_monit_updated_at: retorno[0].updatedAt,
        interface: retorno[0].interface
      }
      this.geradoresAdicionados.push(itens)
      this.usina.gerador = ''
      setTimeout(() => {
        this.loadingGeradores = false
      }, 500)
      // await Api.get('geradores/' + item)
      //   .then(res => {
      //     this.usina.gerador = ''
      //     this.loadingGeradores = false
      //     console.log(res.data)
      //     this.geradoresAdicionados.push(res.data)
      //   })
      //   .catch(err => {
      //     this.loadingGeradores = false
      //     this.$root.SnackControl.open(this, {
      //       text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao adicionar o gerador!',
      //       color: 'error'
      //     })
      //     console.log(err)
      //   })
    },
    inversorLabel (interfaceId) {
      if (this.interfacesSelect.find(item => item.value === interfaceId).searchByInversor) {
        return 'Número de série - Inversor'
      }
      return 'Gerador'
    },
    retornaStatusInterface (stat) {
      switch (stat) {
        case 0:
          return 'Offline'
          // eslint-disable-next-line no-unreachable
          break
        case 1:
          return 'Online'
          // eslint-disable-next-line no-unreachable
          break
        case 2:
          return 'Alerta'
          // eslint-disable-next-line no-unreachable
          break
        case -1:
          return 'Não definido'
          // eslint-disable-next-line no-unreachable
          break
        case -2:
          return 'Sem conexão'
          // eslint-disable-next-line no-unreachable
          break
        case -3:
          return 'Sem retorno'
          // eslint-disable-next-line no-unreachable
          break
        default:
          return stat
          // eslint-disable-next-line no-unreachable
          break
      }
    },
    confirmaRemover (item, index) {
      this.dialogExcluirGerador = true
      this.geradorDetalhe = item
      this.geradorDetalheIndex = index
    },
    removerGerador (index) {
      this.geradoresAdicionados.splice(index, 1)

      this.dialogExcluirGerador = false
    },
    confirmaRemoverInversor (item, index) {
      this.dialogExcluirInversorAdicionado = true
      this.inversorDetalhe = item
      this.inversorDetalheIndex = index
    },
    removerInversor (index) {
      this.inversoresAdicionados.splice(index, 1)

      this.dialogExcluirInversorAdicionado = false
    },
    verificaTipoUsuario (integrador) {
      if (this.user.uuid_int_id || this.user.uuid_dis_id) {
        return false
      } else {
        if (!integrador) {
          return true
        } else {
          return false
        }
      }
    },
    filtraNomeGerador (ger) {
      let nome = ''
      if (ger.uge_nome) {
        nome += ger.uge_nome
      } else if (ger.name) {
        nome += ger.name
      } else {
        nome += ger.sn
      }
      if (typeof ger.status === 'number') {
        nome += ' / ' + this.retornaStatusInterface(ger.status)
      } else {
        nome += ' / ' + this.retornaStatusInterface(ger.status.uss_nome)
      }
      if (ger.atualizado_em) {
        nome += ' / ' + ger.atualizado_em
      }
      return nome
    },
    async getGeoposicao () {
      if (this.loadingGeoposition) return false
      if (this.usina.usi_cep.length !== 8) return false
      if (this.usina.uuid_int_id === '') return false
      this.loadingGeoposition = true
      let data = {
        uuid_int_id: this.usina.uuid_int_id,
        usi_cep: this.usina.usi_cep
      }
      await Api.post('usinas/geoposicao', data)
        .then(res => {
          if (res.data.latitude && res.data.longitude) {
            this.usina.usi_latitude = res.data.latitude
            this.usina.usi_longitude = res.data.longitude
          }
          this.loadingGeoposition = false
        })
        .catch(err => {
          this.loadingGeoposition = false
          this.usina.usi_latitude = ''
          this.usina.usi_longitude = ''
          console.log(err)
        })
    },
    searchGeradores: _debounce(function () {
      if (this.serchField.length < 3) return
      this.getGeradores()
    }, 500),
    async getGeradores () {
      this.loadingGeradores = true
      let endpoint = ''
      if (this.user.uuid_int_id) {
        endpoint = 'geradores/interface/' + this.usina.interface + '?integrador=' + this.user.uuid_int_id
      }
      if (this.user.uuid_dis_id) {
        endpoint = 'geradores/interface/' + this.usina.interface + '?distribuidor=' + this.user.uuid_dis_id
      }
      if (!this.user.uuid_int_id && !this.user.uuid_dis_id) {
        endpoint = 'geradores/interface/' + this.usina.interface + '?integrador=' + this.usina.uuid_int_id
      }
      if (!this.user.uuid_int_id && !this.user.uuid_dis_id) {
        endpoint = 'geradores/interface/' + this.usina.interface + '?integrador=' + this.usina.uuid_int_id
      }

      if (this.serchField) {
        endpoint += `&busca=${this.serchField}`
      }

      await Api.get(endpoint, { busca: this.serchField })
        .then(res => {
          this.todosGeradores = res.data
          var arrayGera = []
          res.data.map(ger => {
            arrayGera.push({
              'text': this.filtraNomeGerador(ger),
              'value': ger.uuid_uge_id ? ger.uuid_uge_id : ger.uid
            })
          })
          this.geradores = arrayGera
          this.loadingGeradores = false
        })
        .catch(err => {
          this.loadingGeradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os geradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getStatus () {
      this.loadingStatus = true
      await Api.get('usinas-status')
        .then(res => {
          var arrayStat = []
          res.data.map(sta => {
            arrayStat.push({
              'text': sta.uss_nome,
              'value': sta.uuid_uss_id
            })
          })
          this.status = arrayStat
          this.loadingStatus = false
        })
        .catch(err => {
          this.loadingStatus = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os status!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getIntegradores (distribuidor = null, cadastro = false) {
      this.loadingIntegradores = true

      let url = 'integradores'

      if (distribuidor) {
        url = `integradores/distribuidor/${distribuidor}`
      }

      await Api.get(url)
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })

          if (cadastro || (!cadastro && !distribuidor)) {
            this.integradoresCadastro = arrayInt
          }

          if (!cadastro) {
            this.integradores = arrayInt
          }

          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getClientes (integ) {
      this.loadingClientes = true
      await Api.get('clientes/integrador/' + integ)
        .then(res => {
          var arrayCli = []
          res.data.map(cli => {
            arrayCli.push({
              'text': cli.cli_nome,
              'value': cli.uuid_cli_id
            })
          })
          this.clientes = arrayCli
          this.loadingClientes = false
          this.verificaTipoUsuario(this.usina.uuid_int_id)
        })
        .catch(err => {
          this.loadingClientes = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os clientes!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getUnidades () {
      this.loadingUnidades = true
      await Api.get('unidades-consumidoras/cliente/' + this.usina.cliente.uuid_cli_id)
        .then(res => {
          var arrayUni = []
          res.data.map(uni => {
            arrayUni.push({
              'text': uni.uco_nome,
              'value': uni.uuid_uco_id
            })
          })
          this.unidades = arrayUni
          this.loadingUnidades = false
        })
        .catch(err => {
          this.loadingUnidades = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as unidades consumidoras!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getInversores () {
      this.loadingInversores = true
      await Api.get('inversores/disponiveis')
        .then(res => {
          var arrayInv = []
          res.data.map(inv => {
            arrayInv.push({
              'text': inv.inv_marca,
              'value': inv.uuid_inv_id
            })
          })
          this.inversores = arrayInv
          this.loadingInversores = false
        })
        .catch(err => {
          this.loadingInversores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os inversores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getDistribuidores () {
      this.loadingDistribuidores = true
      await Api.get('distribuidores')
        .then(res => {
          var arrayDists = []
          res.data.map(dist => {
            arrayDists.push({
              'text': dist.dis_nome,
              'value': dist.uuid_dis_id
            })
          })
          this.distribuidores = arrayDists
          this.loadingDistribuidores = false
        })
        .catch(err => {
          this.loadingDistribuidores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os distribuidores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    applyFilter () {
      if (this.distribuidorAnterior && this.distribuidor !== this.distribuidorAnterior) {
        this.integrador = ''
      }

      let query = Object.assign({},
        this.distribuidor ? { distribuidor: this.distribuidor } : '',
        this.integrador ? { integrador: this.integrador } : '',
        this.searchFinal ? { busca: this.searchFinal } : ''
      )

      this.$router.replace({name: 'Usina', query: query}).catch(() => {})
      this.dados = []
      this.distribuidorAnterior = this.distribuidor
      this.getIntegradores(this.distribuidor)
      this.getUsinas()
    },
    buscaItens () {
      this.searchFinal = this.search
      this.options.page = 1
      this.applyFilter()
    },
    limparBusca () {
      this.search = null
      this.searchFinal = null
      this.options.page = 1
      this.applyFilter()
    },
    async getUsinas () {
      this.carregando = true
      this.total = 0

      const { page, itemsPerPage } = this.options
      let pagina = 1
      let itensPagina = 10
      let endpoint = ''

      if (page) {
        pagina = page
      }
      if (itemsPerPage) {
        itensPagina = itemsPerPage
      }
      if (this.distribuidor) {
        endpoint += '&distribuidor=' + this.distribuidor
      }
      if (this.integrador) {
        endpoint += '&integrador=' + this.integrador
      }
      if (this.searchFinal) {
        endpoint += `&busca=${this.searchFinal}`
      }

      await Api.get(`usinas?page=${pagina}&per_page=${itensPagina}${endpoint}`)
        .then(res => {
          this.dados = res.data.data
          this.total = res.data.total
          this.carregando = false
        })
        .catch(err => {
          this.carregando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as usinas!',
            color: 'error'
          })
          console.log(err)
        })
    },
    goToVisaoGeral (item) {
      this.$router.push({ name: 'VisaoGeralInterna', params: { uuid: item.uuid_usi_id } }).catch(() => {})
    },
    openNovo (item) {
      this.salvando = true
      this.dialogNovo = true
      Api.get('usinas/' + item.uuid_usi_id)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          if (response.data.usi_uf) {
            this.filterCidade(response.data.usi_uf)
          }
          this.usina = JSON.parse(JSON.stringify(response.data))
          if (response.data.status) {
            this.usina.uuid_uss_id = response.data.status.uuid_uss_id
          }
          if (response.data.integrador) {
            this.usina.uuid_int_id = response.data.integrador.uuid_int_id
            this.getClientes(response.data.integrador.uuid_int_id)
          }
          if (response.data.cliente) {
            this.usina.uuid_cli_id = response.data.cliente.uuid_cli_id
          }
          if (response.data.usi_desativado_em) {
            this.usina.usi_desativado_em = moment(response.data.usi_desativado_em).format('DD/MM/YYYY [às] HH:mm[hrs]')
          }
          if (response.data.geradores) {
            this.geradoresAdicionados = response.data.geradores
          }
          if (response.data.inversores) {
            this.inversoresAdicionados = response.data.inversores
          }
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados da usina!',
            color: 'error'
          })
        })
    },
    removeImagem () {
      this.usina.usi_imagem = ''
      this.dialogDeletarImagem = false
      this.usina.remover_imagem = true
    },
    saveEditUsina () {
      if (!this.$refs.formUsina.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'usinas/novo'
      if (this.usina.uuid_usi_id) {
        endpoint = 'usinas/edita'
      }
      if (endpoint === 'usinas/novo') {
        if (this.user && this.user.uuid_int_id) {
          this.usina.uuid_int_id = this.user.uuid_int_id
        }
      }
      if (this.$refs.file) {
        this.usina.imagem = this.$refs.file.fileRecords
      }
      this.usina.geradores = this.geradoresAdicionados
      this.usina.inversores = this.inversoresAdicionados
      const formData = new FormData()
      Object.keys(this.usina).map((key) => {
        if (key === 'imagem') {
          if (this.$refs.file) {
            if (this.$refs.file.fileRecords && this.$refs.file.fileRecords.length > 0) {
              formData.append(`imagem`, this.usina.usi_imagem[0].file)
            }
          }
        } else if (key === 'geradores') {
          formData.append('geradores', JSON.stringify(this.usina.geradores))
        } else if (key === 'inversores') {
          formData.append('inversores', JSON.stringify(this.usina.inversores))
        } else if (key === 'cliente') {
          formData.append('cliente', JSON.stringify(this.usina.cliente))
        } else if (key === 'status') {
          formData.append('status', JSON.stringify(this.usina.status))
        } else if (key === 'integrador') {
          formData.append('integrador', JSON.stringify(this.usina.integrador))
        } else {
          if (this.usina[key] != null) {
            formData.append(key, this.usina[key])
          }
        }
      })
      Api.post(endpoint, formData)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.closeDialogUsina()
          this.getUsinas()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    opendialogDelete (item) {
      this.usina = JSON.parse(JSON.stringify(item))
      this.dialogExcluir = true
    },
    cancelDialogDelete () {
      this.closeDialogUsina()
      this.dialogExcluir = false
    },
    removeUsina () {
      this.salvando = true
      Api.delete(`usinas/remove/${this.usina.uuid_usi_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.message
          })
          this.dialogExcluir = false
          this.salvando = false
          this.closeDialogUsina()
          this.getUsinas()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.message ? err.response.data.message : 'Erro ao remover usina!',
            color: 'error'
          })
        })
    },
    openDialogDetalhes (item) {
      this.usina = JSON.parse(JSON.stringify(item))
      this.salvando = true
      this.dialogUsina = true
      Api.get('usinas/' + item.uuid_usi_id + '/projeto')
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }

          response.data = {
            ...response.data,
            usp_objetivo_minimo_jan: response.data.usp_objetivo_minimo_jan || this.returnvalorRSIMes(response.data.usp_rsi_jan, 1, response.data.usp_potencia, response.data.usp_eficiencia),
            usp_objetivo_minimo_fev: response.data.usp_objetivo_minimo_fev || this.returnvalorRSIMes(response.data.usp_rsi_fev, 2, response.data.usp_potencia, response.data.usp_eficiencia),
            usp_objetivo_minimo_mar: response.data.usp_objetivo_minimo_mar || this.returnvalorRSIMes(response.data.usp_rsi_mar, 3, response.data.usp_potencia, response.data.usp_eficiencia),
            usp_objetivo_minimo_abr: response.data.usp_objetivo_minimo_abr || this.returnvalorRSIMes(response.data.usp_rsi_abr, 4, response.data.usp_potencia, response.data.usp_eficiencia),
            usp_objetivo_minimo_mai: response.data.usp_objetivo_minimo_mai || this.returnvalorRSIMes(response.data.usp_rsi_mai, 5, response.data.usp_potencia, response.data.usp_eficiencia),
            usp_objetivo_minimo_jun: response.data.usp_objetivo_minimo_jun || this.returnvalorRSIMes(response.data.usp_rsi_jun, 6, response.data.usp_potencia, response.data.usp_eficiencia),
            usp_objetivo_minimo_jul: response.data.usp_objetivo_minimo_jul || this.returnvalorRSIMes(response.data.usp_rsi_jul, 7, response.data.usp_potencia, response.data.usp_eficiencia),
            usp_objetivo_minimo_ago: response.data.usp_objetivo_minimo_ago || this.returnvalorRSIMes(response.data.usp_rsi_ago, 8, response.data.usp_potencia, response.data.usp_eficiencia),
            usp_objetivo_minimo_set: response.data.usp_objetivo_minimo_set || this.returnvalorRSIMes(response.data.usp_rsi_set, 9, response.data.usp_potencia, response.data.usp_eficiencia),
            usp_objetivo_minimo_out: response.data.usp_objetivo_minimo_out || this.returnvalorRSIMes(response.data.usp_rsi_out, 10, response.data.usp_potencia, response.data.usp_eficiencia),
            usp_objetivo_minimo_nov: response.data.usp_objetivo_minimo_nov || this.returnvalorRSIMes(response.data.usp_rsi_nov, 11, response.data.usp_potencia, response.data.usp_eficiencia),
            usp_objetivo_minimo_dez: response.data.usp_objetivo_minimo_dez || this.returnvalorRSIMes(response.data.usp_rsi_dez, 12, response.data.usp_potencia, response.data.usp_eficiencia)
          }

          this.usina_detalhes = JSON.parse(JSON.stringify(response.data))
          if (response.data.usp_data_instalacao) {
            this.dataInstalacao = response.data.usp_data_instalacao
            this.dataFormatadaInstalacao = moment(this.dataInstalacao).format('L')
            this.updatePickerModalDataInstalacao = this.$root.Formatter.parseDate(this.dataFormatadaInstalacao)
          }
          if (response.data.usina && response.data.usina.status) {
            this.usina_detalhes.uuid_uss_id = response.data.usina.status.uuid_uss_id
          }
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados da usina!',
            color: 'error'
          })
        })
    },
    getDadosRSI () {
      this.salvando = true
      this.selectRSI = []
      this.selectRSITotal = []
      this.usina_detalhes.angulo = ''
      this.usina_detalhes.distancia = ''
      this.usina_detalhes.estacao = ''
      this.usina_detalhes.inclinicao = ''
      this.usina_detalhes.municipio = ''
      this.usina_detalhes.rsiSelect = ''
      Api.get('usinas/' + this.usina.uuid_usi_id + '/rsi')
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          var arrayItens = []
          if (response.data.sugestoes.length) {
            response.data.sugestoes.map((ret, ind) => {
              arrayItens.push({
                'text': ret.estacao + ' - ' + ret.distancia,
                'value': ind
              })
            })
            this.selectRSI = arrayItens
            this.selectRSITotal = response.data.sugestoes
          }
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados de RSI!',
            color: 'error'
          })
        })
    },
    selecionaEstacaoRSI () {
      this.salvando = true
      let selecionado = this.selectRSITotal[this.usina_detalhes.rsiSelect]
      this.usina_detalhes.angulo = selecionado.angulo
      this.usina_detalhes.distancia = selecionado.distancia
      this.usina_detalhes.estacao = selecionado.estacao
      this.usina_detalhes.inclinicao = selecionado.inclinicao
      this.usina_detalhes.municipio = selecionado.municipio
      this.usina_detalhes.usp_rsi_jan = selecionado.rsi[0].replace(',', '.')
      this.usina_detalhes.usp_rsi_fev = selecionado.rsi[1].replace(',', '.')
      this.usina_detalhes.usp_rsi_mar = selecionado.rsi[2].replace(',', '.')
      this.usina_detalhes.usp_rsi_abr = selecionado.rsi[3].replace(',', '.')
      this.usina_detalhes.usp_rsi_mai = selecionado.rsi[4].replace(',', '.')
      this.usina_detalhes.usp_rsi_jun = selecionado.rsi[5].replace(',', '.')
      this.usina_detalhes.usp_rsi_jul = selecionado.rsi[6].replace(',', '.')
      this.usina_detalhes.usp_rsi_ago = selecionado.rsi[7].replace(',', '.')
      this.usina_detalhes.usp_rsi_set = selecionado.rsi[8].replace(',', '.')
      this.usina_detalhes.usp_rsi_out = selecionado.rsi[9].replace(',', '.')
      this.usina_detalhes.usp_rsi_nov = selecionado.rsi[10].replace(',', '.')
      this.usina_detalhes.usp_rsi_dez = selecionado.rsi[11].replace(',', '.')
      setTimeout(() => {
        this.salvando = false
      }, 500)
    },
    rendimentoAnual () {
      let jan = parseFloat(moment(1, 'MM').daysInMonth()) * parseFloat(this.usina_detalhes.usp_rsi_jan)
      let fev = parseFloat(moment(2, 'MM').daysInMonth()) * parseFloat(this.usina_detalhes.usp_rsi_fev)
      let mar = parseFloat(moment(3, 'MM').daysInMonth()) * parseFloat(this.usina_detalhes.usp_rsi_mar)
      let abr = parseFloat(moment(4, 'MM').daysInMonth()) * parseFloat(this.usina_detalhes.usp_rsi_abr)
      let mai = parseFloat(moment(5, 'MM').daysInMonth()) * parseFloat(this.usina_detalhes.usp_rsi_mai)
      let jun = parseFloat(moment(6, 'MM').daysInMonth()) * parseFloat(this.usina_detalhes.usp_rsi_jun)
      let jul = parseFloat(moment(7, 'MM').daysInMonth()) * parseFloat(this.usina_detalhes.usp_rsi_jul)
      let ago = parseFloat(moment(8, 'MM').daysInMonth()) * parseFloat(this.usina_detalhes.usp_rsi_ago)
      let set = parseFloat(moment(9, 'MM').daysInMonth()) * parseFloat(this.usina_detalhes.usp_rsi_set)
      let out = parseFloat(moment(10, 'MM').daysInMonth()) * parseFloat(this.usina_detalhes.usp_rsi_out)
      let nov = parseFloat(moment(11, 'MM').daysInMonth()) * parseFloat(this.usina_detalhes.usp_rsi_nov)
      let dez = parseFloat(moment(12, 'MM').daysInMonth()) * parseFloat(this.usina_detalhes.usp_rsi_dez)
      let retorno = parseFloat(jan) + parseFloat(fev) + parseFloat(mar) + parseFloat(abr) + parseFloat(mai) + parseFloat(jun) + parseFloat(jul) + parseFloat(ago) + parseFloat(set) + parseFloat(out) + parseFloat(nov) + parseFloat(dez)
      return retorno
    },
    geracaoAnualPrevista () {
      let jan = this.returnvalorRSIMes(this.usina_detalhes.usp_rsi_jan, 1)
      let fev = this.returnvalorRSIMes(this.usina_detalhes.usp_rsi_fev, 2)
      let mar = this.returnvalorRSIMes(this.usina_detalhes.usp_rsi_mar, 3)
      let abr = this.returnvalorRSIMes(this.usina_detalhes.usp_rsi_abr, 4)
      let mai = this.returnvalorRSIMes(this.usina_detalhes.usp_rsi_mai, 5)
      let jun = this.returnvalorRSIMes(this.usina_detalhes.usp_rsi_jun, 6)
      let jul = this.returnvalorRSIMes(this.usina_detalhes.usp_rsi_jul, 7)
      let ago = this.returnvalorRSIMes(this.usina_detalhes.usp_rsi_ago, 8)
      let set = this.returnvalorRSIMes(this.usina_detalhes.usp_rsi_set, 9)
      let out = this.returnvalorRSIMes(this.usina_detalhes.usp_rsi_out, 10)
      let nov = this.returnvalorRSIMes(this.usina_detalhes.usp_rsi_nov, 11)
      let dez = this.returnvalorRSIMes(this.usina_detalhes.usp_rsi_dez, 12)
      let retorno = parseFloat(jan) + parseFloat(fev) + parseFloat(mar) + parseFloat(abr) + parseFloat(mai) + parseFloat(jun) + parseFloat(jul) + parseFloat(ago) + parseFloat(set) + parseFloat(out) + parseFloat(nov) + parseFloat(dez)
      this.geracaoPrevista = retorno.toFixed(2)
      return retorno.toFixed(2)
    },
    returnvalorRSIMes (valor, mes) {
      if (valor && this.usina_detalhes.usp_potencia) {
        let retorno = parseFloat(this.usina_detalhes.usp_potencia.replace(',', '.')) * parseFloat(valor.replace(',', '.')) * parseFloat(moment(mes, 'MM').daysInMonth()) * (parseFloat(this.usina_detalhes.usp_eficiencia.replace(',', '.')) / 100)
        return retorno.toFixed(2)
      } else {
        return ''
      }
    },
    returnvalorRSIPorcentagem (valor, mes) {
      if (valor && this.usina_detalhes.usp_eficiencia) {
        let dado = this.returnvalorRSIMes(valor, mes) / this.geracaoPrevista
        let info = (dado * 100)
        return info.toFixed(2) + '%'
      } else {
        return ''
      }
    },
    editDetalhesUsina () {
      this.salvando = true
      Api.post('usinas/' + this.usina.uuid_usi_id + '/projeto/edita', this.usina_detalhes)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.closeDialogUsina()
          this.closeDialogDetalhesUsina()
          this.getUsinas()
          this.$root.SnackControl.open(this, {
            text: 'Dados atualizados com sucesso!',
            color: 'success'
          })
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao atualizar os dados da usina!',
            color: 'error'
          })
        })
    },
    closeDialogDetalhesUsina () {
      this.usina_detalhes = {
        usp_potencia: '',
        usp_eficiencia: '',
        usp_data_instalacao: '',
        usp_total_investido: '',
        usp_tarifa_referencia: '',
        rsiSelect: '',
        usp_rsi_jan: '',
        usp_rsi_fev: '',
        usp_rsi_mar: '',
        usp_rsi_abr: '',
        usp_rsi_mai: '',
        usp_rsi_jun: '',
        usp_rsi_jul: '',
        usp_rsi_ago: '',
        usp_rsi_set: '',
        usp_rsi_out: '',
        usp_rsi_nov: '',
        usp_rsi_dez: '',
        uuid_uss_id: ''
      }
      if (this.$refs.formUsinaDetalhes) {
        this.$refs.formUsinaDetalhes.resetValidation()
      }
      this.dialogUsina = false
    },
    closeDialogUsina () {
      this.usina = {
        usi_nome: '',
        usi_cep: '',
        usi_uf: '',
        usi_cidade: '',
        usi_bairro: '',
        usi_rua: '',
        usi_numero: '',
        usi_complemento: '',
        usi_latitude: '',
        usi_longitude: '',
        usi_desativada: false,
        usi_desativacao: '',
        uuid_int_id: this.user.uuid_int_id ? this.user.uuid_int_id : '',
        usi_imagem: '',
        uuid_cli_id: ''
      }
      this.geradoresAdicionados = []
      this.inversoresAdicionados = []
      if (this.$refs.formUsina) {
        this.$refs.formUsina.resetValidation()
      }
      this.dialogNovo = false
    },
    openDialogCreditos (item) {
      this.dialogCreditos = true
      this.usina = JSON.parse(JSON.stringify(item))
      this.carregandoCreditos = true
      this.unidades = []
      this.getUnidades()
      Api.get('usinas/' + item.uuid_usi_id + '/sistema-credito')
        .then((response) => {
          if (response.data.error) {
            this.carregandoCreditos = false
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          if (response.data.length) {
            response.data.map(item => {
              item.usc_vigencia = item.usc_vigencia ? moment(item.usc_vigencia).format('DD/MM/YYYY') : ''
              item.usc_percentual = item.usc_percentual ? item.usc_percentual.replace('.', ',') + '%' : ''
            })
          }
          this.dadosCreditos = response.data
          this.carregandoCreditos = false
        })
        .catch((error) => {
          this.carregandoCreditos = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados de sistema de créditos da usina!',
            color: 'error'
          })
        })
    },
    openNovoCredito (item) {
      this.salvando = true
      this.dialogNovoCredito = true
      Api.get('usinas/' + this.usina.uuid_usi_id + '/sistema-credito/' + item.uuid_usc_id)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.credito = JSON.parse(JSON.stringify(response.data))
          if (response.data.unidade) {
            this.credito.uuid_uco_id = response.data.unidade.uuid_uco_id
          }
          if (response.data.usc_vigencia) {
            this.dataVigencia = response.data.usc_vigencia
            this.dataFormatadaVigencia = moment(this.dataInstalacao).format('L')
            this.updatePickerModalDataVigencia = this.$root.Formatter.parseDate(this.dataFormatadaVigencia)
          }
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados do sistema de crédito!',
            color: 'error'
          })
        })
    },
    saveEditCredito () {
      if (!this.$refs.formCredito.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'usinas/' + this.usina.uuid_usi_id + '/sistema-credito/novo'
      if (this.credito.uuid_usc_id) {
        endpoint = 'usinas/' + this.usina.uuid_usi_id + '/sistema-credito/edita'
      }
      Api.post(endpoint, this.credito)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.closeDialogCreditos()
          this.openDialogCreditos(this.usina)
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    opendialogDeleteCredito (item) {
      this.credito = JSON.parse(JSON.stringify(item))
      this.dialogExcluirCredito = true
    },
    cancelDialogDeleteCredito () {
      this.closeDialogCreditos()
      this.dialogExcluirCredito = false
    },
    removeCredito () {
      this.salvando = true
      Api.delete(`usinas/${this.usina.uuid_usi_id}/sistema-credito/remove/${this.credito.uuid_usc_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.message
          })
          this.dialogExcluirCredito = false
          this.salvando = false
          this.closeDialogCreditos()
          this.openDialogCreditos(this.usina)
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover sistema de crédito!',
            color: 'error'
          })
        })
    },
    closeDialogCreditos () {
      this.credito = {
        usc_vigencia: '',
        usc_percentual: '',
        uuid_uco_id: ''
      }
      if (this.$refs.formCredito) {
        this.$refs.formCredito.resetValidation()
      }
      this.dialogNovoCredito = false
    },
    openDialogInversores (item) {
      this.dialogInversor = true
      this.usina = JSON.parse(JSON.stringify(item))
      this.carregandoInversores = true
      this.getInversores()
      Api.get('usinas/' + item.uuid_usi_id + '/inversores')
        .then((response) => {
          if (response.data.error) {
            this.carregandoInversores = false
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          if (response.data.length) {
            response.data.map(item => {
              item.inversor.inv_garantia = item.inversor.inv_garantia ? moment(item.inversor.inv_garantia).format('DD/MM/YYYY') : ''
            })
          }
          this.dadosInversores = response.data
          this.carregandoInversores = false
        })
        .catch((error) => {
          this.carregandoInversores = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados de inversores!',
            color: 'error'
          })
        })
    },
    returnInterface (item) {
      let dados = this.interfacesSelect.filter((ret) => ret.value === item)
      if (dados.length) {
        return dados[0].text
      } else {
        return '-'
      }
    },
    selecionaInversor (item) {
      this.loadingInversorSelecionado = true
      Api.get('inversores/' + item)
        .then((response) => {
          this.loadingInversorSelecionado = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.inversorPai.inversor.inv_marca = response.data.inv_marca
          this.inversorPai.inversor.inv_modelo = response.data.inv_modelo
          this.inversorPai.inversor.inv_potencia = response.data.inv_potencia
          this.inversorPai.inversor.inv_serial = response.data.inv_serial
          this.inversorPai.inversor.inv_garantia = response.data.inv_garantia
          this.inversorPai.inversor.inv_tipo = response.data.inv_tipo
        })
        .catch((error) => {
          this.loadingInversorSelecionado = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados do inversor!',
            color: 'error'
          })
        })
    },
    openNovoInversor (item) {
      this.salvando = true
      this.dialogNovoInversor = true
      Api.get('usinas/' + this.usina.uuid_usi_id + '/inversores/' + item.uuid_inu_id)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.inversorPai = JSON.parse(JSON.stringify(response.data))
          if (response.data.inversor.status) {
            this.inversorPai.inversor.uuid_uss_id = response.data.inversor.status.uuid_uss_id
          }
          if (response.data.inversor) {
            this.dataGarantia = response.data.inversor.inv_garantia ? response.data.inversor.inv_garantia : ''
            if (this.dataGarantia) {
              this.dataFormatadaGarantia = moment(this.dataGarantia).format('L')
              this.updatePickerModalDataGarantia = this.$root.Formatter.parseDate(this.dataFormatadaGarantia)
            }
          }
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados do inversor!',
            color: 'error'
          })
        })
    },
    saveEditInversor () {
      if (!this.$refs.formInversor.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'usinas/' + this.usina.uuid_usi_id + '/inversores/novo'
      if (this.inversorPai.uuid_inu_id) {
        endpoint = 'usinas/' + this.usina.uuid_usi_id + '/inversores/edita'
      }
      Api.post(endpoint, this.inversorPai)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.closeDialogInversores()
          this.openDialogInversores(this.usina)
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    opendialogDeleteInversor (item) {
      this.inversorPai = JSON.parse(JSON.stringify(item))
      this.dialogExcluirInversor = true
    },
    cancelDialogDeleteInversor () {
      this.closeDialogInversores()
      this.dialogExcluirInversor = false
    },
    removeInversor () {
      this.salvando = true
      Api.delete(`usinas/${this.usina.uuid_usi_id}/inversores/remove/${this.inversorPai.uuid_inu_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.message
          })
          this.dialogExcluirInversor = false
          this.salvando = false
          this.closeDialogInversores()
          this.openDialogInversores(this.usina)
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover inversor!',
            color: 'error'
          })
        })
    },
    closeDialogInversores () {
      this.inversorPai = {
        inu_painel_quantidade: '',
        inu_painel_potencia: '',
        inv_garantia: '',
        inv_status: false,
        inversor: {
          inv_status: '',
          inv_garantia: '',
          uuid_uss_id: '',
          inv_serial: '',
          inv_marca: '',
          inv_tipo: '',
          inv_potencia: '',
          uuid_inv_id: '',
          inv_modelo: ''
        }
      }
      if (this.$refs.formInversor) {
        this.$refs.formInversor.resetValidation()
      }
      this.dialogNovoInversor = false
    },
    openDialogIndicadores (item) {
      this.dialogIndicadores = true
      this.usina = JSON.parse(JSON.stringify(item))
      this.carregandoIndicadores = true
      Api.get('usinas/' + item.uuid_usi_id + '/indicadores')
        .then((response) => {
          if (response.data.error) {
            this.carregandoIndicadores = false
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          if (response.data.length) {
            response.data.map(item => {
              item.uin_data = item.uin_data ? moment(item.uin_data).format('DD/MM/YYYY') : ''
            })
          }
          this.dadosIndicadores = response.data
          this.carregandoIndicadores = false
        })
        .catch((error) => {
          this.carregandoIndicadores = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados de indicadores!',
            color: 'error'
          })
        })
    },
    openNovoIndicador (item) {
      this.salvando = true
      this.dialogNovoIndicador = true
      Api.get('usinas/' + this.usina.uuid_usi_id + '/indicadores/' + item.uuid_uin_id)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.indicador = JSON.parse(JSON.stringify(response.data))
          if (response.data.uin_data) {
            this.dataIndicador = response.data.uin_data
            this.dataFormatadaIndicador = moment(this.dataIndicador).format('L')
            this.updatePickerModalDataIndicador = this.$root.Formatter.parseDate(this.dataFormatadaIndicador)
          }
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados do indicador!',
            color: 'error'
          })
        })
    },
    saveEditIndicador () {
      if (!this.$refs.formIndicador.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'usinas/' + this.usina.uuid_usi_id + '/indicadores/novo'
      if (this.indicador.uuid_uin_id) {
        endpoint = 'usinas/' + this.usina.uuid_usi_id + '/indicadores/edita'
      }
      Api.post(endpoint, this.indicador)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.closeDialogIndicadores()
          this.openDialogIndicadores(this.usina)
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    opendialogDeleteIndicador (item) {
      this.indicador = JSON.parse(JSON.stringify(item))
      this.dialogExcluirIndicador = true
    },
    cancelDialogDeleteIndicador () {
      this.closeDialogIndicadores()
      this.dialogExcluirIndicador = false
    },
    removeIndicador () {
      this.salvando = true
      Api.delete(`usinas/${this.usina.uuid_usi_id}/indicadores/remove/${this.indicador.uuid_uin_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.message
          })
          this.dialogExcluirIndicador = false
          this.salvando = false
          this.closeDialogIndicadores()
          this.openDialogIndicadores(this.usina)
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover indicador!',
            color: 'error'
          })
        })
    },
    closeDialogIndicadores () {
      this.indicador = {
        uin_data: '',
        uin_hora: '',
        uin_campo: '',
        uin_valor: ''
      }
      if (this.$refs.formIndicador) {
        this.$refs.formIndicador.resetValidation()
      }
      this.dialogNovoIndicador = false
    },
    formataProducaoDiaria (valor) {
      return valor ? `${valor.replace('.', ',')} Kwh` : ''
    },
    // openDialogProducaoInstantanea (item) {
    //   this.dadosProducaoInstantaneaInversor = []
    //   this.inversorSelect = null
    //   this.dialogProducaoInstantanea = true
    //   this.usina = JSON.parse(JSON.stringify(item))
    //   this.carregandoProducaoInstantanea = true
    //   this.usinaSelecionada = item.uuid_usi_id
    //   this.getProducaoInstantanea()
    // },
    openDialogProducaoDiaria (item) {
      this.dialogProducaoDiaria = true
      this.usina = JSON.parse(JSON.stringify(item))
      this.getProducaoDiaria()
      this.getInversoresUsina()
      this.getProducaoDiariaInversor()
    },
    getProducaoDiaria () {
      this.carregandoProducaoDiaria = true
      Api.get('usinas/' + this.usina.uuid_usi_id + `/producao/diaria?de=${this.de_producao_diaria}&ate=${this.ate_producao_diaria}`)
        .then((response) => {
          if (response.data.error) {
            this.carregandoProducaoDiaria = false
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          if (response.data.length) {
            response.data.map(item => {
              item.upr_producao = item.upr_producao ? `${item.upr_producao.replace('.', ',')} Kwh` : ''
              item.upr_data = item.upr_data ? moment(item.upr_data).format('DD/MM/YYYY') : ''
            })
          }
          this.dadosProducaoDiaria = response.data
          this.carregandoProducaoDiaria = false
        })
        .catch((error) => {
          this.carregandoProducaoDiaria = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados da produção diária!',
            color: 'error'
          })
        })
    },
    openNovaProducaoDiaria (item = null) {
      this.salvando = true
      this.dataProducaoDiaria = ''
      this.dataFormatadaProducaoDiaria = ''
      this.dialogNovaProducaoDiaria = true
      if (this.$refs.formProducaoDiaria) {
        this.$refs.formProducaoDiaria.resetValidation()
      }

      if (item) {
        Api.get('usinas/' + this.usina.uuid_usi_id + '/producao/' + item.uuid_upr_id)
          .then((response) => {
            this.salvando = false
            if (response.data.error) {
              this.$root.SnackControl.open(this, {
                text: response.data.error,
                color: 'error'
              })
              return false
            }
            this.producaoDiaria = JSON.parse(JSON.stringify(response.data))
            if (response.data.upr_data) {
              this.dataProducaoDiaria = response.data.upr_data
              this.dataFormatadaProducaoDiaria = moment(this.dataProducaoDiaria).format('L')
              this.updatePickerModalDataProducaoDiaria = this.$root.Formatter.parseDate(this.dataFormatadaProducaoDiaria)
            }
          })
          .catch((error) => {
            this.salvando = false
            console.log(error.response)
            this.$root.SnackControl.open(this, {
              text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados da produção diária!',
              color: 'error'
            })
          })
      } else {
        this.salvando = false
      }
    },
    saveEditProducaoDiaria () {
      if (!this.$refs.formProducaoDiaria.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'usinas/' + this.usina.uuid_usi_id + '/producao/novo'
      if (this.producaoDiaria.uuid_upr_id) {
        endpoint = 'usinas/' + this.usina.uuid_usi_id + '/producao/edita'
      }
      Api.post(endpoint, this.producaoDiaria)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.closeDialogProducaoDiaria()
          this.openDialogProducaoDiaria(this.usina)
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    opendialogDeleteProducaoDiaria (item) {
      this.producaoDiaria = JSON.parse(JSON.stringify(item))
      this.dialogExcluirProducaoDiaria = true
    },
    cancelDialogDeleteProducaoDiaria () {
      this.closeDialogProducaoDiaria()
      this.dialogExcluirProducaoDiaria = false
    },
    removeProducaoDiaria () {
      this.salvando = true
      Api.delete(`usinas/${this.usina.uuid_usi_id}/producao/remove/${this.producaoDiaria.uuid_upr_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.message
          })
          this.dialogExcluirProducaoDiaria = false
          this.salvando = false
          this.closeDialogProducaoDiaria()
          this.openDialogProducaoDiaria(this.usina)
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover a produção diária!',
            color: 'error'
          })
        })
    },
    closeDialogProducaoDiaria () {
      this.producaoDiaria = {
        upr_data: '',
        upr_hora: '',
        upr_producao: '',
        upr_tipo: 1
      }
      this.dataProducaoDiaria = ''
      this.dataFormatadaProducaoDiaria = ''
      if (this.$refs.formProducaoDiaria) {
        this.$refs.formProducaoDiaria.resetValidation()
      }
      this.dialogNovaProducaoDiaria = false
    },
    getProducaoDiariaInversor (inversor = 'todos') {
      inversor = !inversor ? 'todos' : inversor
      this.carregandoProducaoDiariaInversor = true
      Api.get('usinas/' + this.usina.uuid_usi_id + `/producao/diaria?de=${this.de_producao_diaria_inversor}&ate=${this.ate_producao_diaria_inversor}&inversor=${inversor}`)
        .then((response) => {
          if (response.data.error) {
            this.carregandoProducaoDiariaInversor = false
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          if (response.data.length) {
            response.data.map(item => {
              item.upr_producao = this.formataProducaoDiaria(item.upr_producao)
              item.upr_data = item.upr_data ? moment(item.upr_data).format('DD/MM/YYYY') : ''
              item.inv_serial = item.inversor.inv_serial
            })
          }
          this.dadosProducaoDiariaInversor = response.data
          this.carregandoProducaoDiariaInversor = false
        })
        .catch((error) => {
          this.carregandoProducaoDiariaInversor = false
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados da produção diáriaaaa!',
            color: 'error'
          })
        })
    },
    getProducaoInstantaneaInversor (inversor) {
      Api.get(`usinas/${this.usinaSelecionada}/producao/instantanea?de=${this.de_inversor}&ate=${this.ate_inversor}&inversor=${inversor}`)
        .then((response) => {
          if (response.data.error) {
            this.carregandoProducaoInstantaneaInversor = false
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          if (response.data.length) {
            response.data.map(item => {
              item.diferenca = this.formataProducaoDiaria(item.diferenca)
              item.upr_data = item.upr_data ? moment(item.upr_data).format('DD/MM/YYYY') : ''
            })
          }
          this.dadosProducaoInstantaneaInversor = response.data
          this.carregandoProducaoInstantaneaInversor = false
        })
        .catch((error) => {
          this.carregandoProducaoInstantanea = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados da produção diária!',
            color: 'error'
          })
        })
    },
    getProducaoInstantanea () {
      Api.get(`usinas/${this.usinaSelecionada}/producao/instantanea?de=${this.de}&ate=${this.ate}`)
        .then((response) => {
          if (response.data.error) {
            this.carregandoProducaoInstantanea = false
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          if (response.data.length) {
            response.data.map(item => {
              console.log(item, 'item')
              item.diferenca = this.formataProducaoDiaria(item.diferenca)
              item.upr_data = item.upr_data ? moment(item.upr_data).format('DD/MM/YYYY') : ''
            })
          }
          this.dadosProducaoInstantanea = response.data
          this.carregandoProducaoInstantanea = false
        })
        .catch((error) => {
          this.carregandoProducaoInstantanea = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados da produção diária!',
            color: 'error'
          })
        })
      this.getInversoresUsina()
    },
    openDialogProducaoInstantanea (item) {
      this.dadosProducaoInstantaneaInversor = []
      this.inversorSelect = null
      this.dialogProducaoInstantanea = true
      this.usina = JSON.parse(JSON.stringify(item))
      this.carregandoProducaoInstantanea = true
      this.usinaSelecionada = item.uuid_usi_id
      this.getProducaoInstantanea()
    },
    openNovaProducaoInstantanea (item = null) {
      this.salvando = true
      this.dataProducaoInstantanea = ''
      this.dataFormatadaProducaoInstantanea = ''
      this.dialogNovaProducaoInstantanea = true
      if (this.$refs.formProducaoInstantanea) {
        this.$refs.formProducaoInstantanea.resetValidation()
      }

      if (item) {
        Api.get('usinas/' + this.usina.uuid_usi_id + '/producao/' + item.uuid_upr_id)
          .then((response) => {
            this.salvando = false
            if (response.data.error) {
              this.$root.SnackControl.open(this, {
                text: response.data.error,
                color: 'error'
              })
              return false
            }
            this.producaoInstantanea = JSON.parse(JSON.stringify(response.data))
            if (response.data.upr_data) {
              this.dataProducaoInstantanea = response.data.upr_data
              this.dataFormatadaProducaoInstantanea = moment(this.dataProducaoInstantanea).format('L')
              this.updatePickerModalDataProducaoInstantanea = this.$root.Formatter.parseDate(this.dataFormatadaProducaoInstantanea)
            }
          })
          .catch((error) => {
            this.salvando = false
            console.log(error.response)
            this.$root.SnackControl.open(this, {
              text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados da produção instantânea!',
              color: 'error'
            })
          })
      } else {
        this.salvando = false
      }
    },
    saveEditProducaoInstantanea () {
      if (!this.$refs.formProducaoInstantanea.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'usinas/' + this.usina.uuid_usi_id + '/producao/novo'
      if (this.producaoInstantanea.uuid_upr_id) {
        endpoint = 'usinas/' + this.usina.uuid_usi_id + '/producao/edita'
      }
      Api.post(endpoint, this.producaoInstantanea)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.closeDialogProducaoInstantanea()
          this.openDialogProducaoInstantanea(this.usina)
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    opendialogDeleteProducaoInstantanea (item) {
      this.producaoInstantanea = JSON.parse(JSON.stringify(item))
      this.dialogExcluirProducaoInstantanea = true
    },
    cancelDialogDeleteProducaoInstantanea () {
      this.closeDialogProducaoInstantanea()
      this.dialogExcluirProducaoInstantanea = false
    },
    removeProducaoInstantanea () {
      this.salvando = true
      Api.delete(`usinas/${this.usina.uuid_usi_id}/producao/remove/${this.producaoInstantanea.uuid_upr_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.message
          })
          this.dialogExcluirProducaoInstantanea = false
          this.salvando = false
          this.closeDialogProducaoInstantanea()
          this.openDialogProducaoInstantanea(this.usina)
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover a produção instantânea!',
            color: 'error'
          })
        })
    },
    closeDialogProducaoInstantanea () {
      this.producaoInstantanea = {
        upr_data: '',
        upr_hora: '',
        upr_producao: '',
        uuid_inv_id: '',
        upr_tipo: 2
      }
      this.dataProducaoInstantanea = ''
      this.dataFormatadaProducaoInstantanea = ''
      if (this.$refs.formProducaoInstantanea) {
        this.$refs.formProducaoInstantanea.resetValidation()
      }
      this.tabProducaoInstantanea = 0
      this.dialogNovaProducaoInstantanea = false
    },
    searchCep (cep = '') {
      if (cep.length === 8) {
        this.loadingCep = true
        axios.get('https://viacep.com.br/ws/' + cep + '/json/')
          .then((response) => {
            if (!response.data.erro) {
              this.usina.usi_rua = response.data.logradouro
              this.usina.usi_bairro = response.data.bairro
              this.usina.usi_complemento = response.data.complemento
              if (response.data.uf) {
                this.usina.usi_uf = response.data.uf
                this.usina.usi_cidade = response.data.localidade
                this.filterCidade(response.data.uf)
              }
            }
          })
          .catch(err => {
            console.log(err)
            this.$root.SnackControl.open(this, {
              text: 'Erro ao buscar por CEP!',
              color: 'error'
            })
          }).finally(() => {
            this.loadingCep = false
          })
        this.getGeoposicao()
      }
    },
    getEstados () {
      this.loadingEstados = true
      axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome')
        .then((response) => {
          for (let estado = 0; estado < response.data.length; estado++) {
            this.estados.push({
              text: response.data[estado].nome,
              value: response.data[estado].sigla
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar os estados!',
            color: 'error'
          })
        })
      this.loadingEstados = false
    },
    getCidade () {
      this.loadingCidades = true
      axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/municipios')
        .then((response) => {
          for (let cidade = 0; cidade < response.data.length; cidade++) {
            this.cidades.push({
              text: response.data[cidade].nome,
              value: response.data[cidade].nome,
              uf: response.data[cidade].microrregiao.mesorregiao.UF.sigla
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar as cidades!',
            color: 'error'
          })
        })
      this.loadingCidades = false
    },
    filterCidade (estado) {
      this.cidadesFiltradas = this.cidades.filter(city => city.uf === estado)
    },
    openDialogOcorrencias (item) {
      this.usina = JSON.parse(JSON.stringify(item))
      this.dialogOcorrencias = true
      this.getOcorrencia()
    },
    async getOcorrencia () {
      this.loadingOcorrencias = true
      await Api.get('usinas/' + this.usina.uuid_usi_id + '/ocorrencias')
        .then(res => {
          res.data.map(item => {
            item.uso_data = item.uso_data ? moment(item.uso_data).format('DD/MM/YYYY') : ''
          })
          this.dadosOcorrencias = res.data
          this.loadingOcorrencias = false
        })
        .catch(err => {
          this.loadingOcorrencias = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as ocorrências!',
            color: 'error'
          })
          console.log(err)
        })
    },
    openNovaOcorrencia (item) {
      this.salvando = true
      this.dialogNovaOcorrencia = true
      Api.get('usinas/' + this.usina.uuid_usi_id + '/ocorrencias/' + item.uuid_uso_id)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.ocorrencia = JSON.parse(JSON.stringify(response.data))
          this.dataOcorrencia = response.data.uso_data
          if (this.dataOcorrencia) {
            this.dataFormatadaOcorrencia = moment(this.dataOcorrencia).format('L')
            this.updatePickerModalDataOcorrencia = this.$root.Formatter.parseDate(this.dataFormatadaOcorrencia)
          }
          // this.ocorrencia.uso_arquivo = null
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados da ocorrência!',
            color: 'error'
          })
        })
    },
    saveEditOcorrencia () {
      if (!this.$refs.formOcorrencia.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'usinas/' + this.usina.uuid_usi_id + '/ocorrencias/novo'
      if (this.ocorrencia.uuid_uso_id) {
        endpoint = 'usinas/' + this.usina.uuid_usi_id + '/ocorrencias/edita'
      }
      if (this.$refs.file) {
        this.ocorrencia.arquivo = this.$refs.file.fileRecords
      }
      const formData = new FormData()
      Object.keys(this.ocorrencia).map((key) => {
        if (key === 'arquivo') {
          if (this.$refs.file) {
            if (this.$refs.file.fileRecords && this.$refs.file.fileRecords.length > 0) {
              formData.append(`arquivo`, this.ocorrencia.arquivo[0].file)
            }
          }
        } else {
          if (this.ocorrencia[key] != null) {
            formData.append(key, this.ocorrencia[key])
          }
        }
      })
      Api.post(endpoint, formData)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.closeDialogOcorrencia()
          this.getOcorrencia()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    removeArquivoOcorrencia () {
      this.ocorrencia.uso_arquivo = ''
      this.ocorrencia.remover_arquivo = true
      this.dialogDeletarArquivoOcorrencia = false
    },
    openDialogDeleteOcorrencia (item) {
      this.ocorrencia = JSON.parse(JSON.stringify(item))
      this.dialogExcluirOcorrencia = true
    },
    cancelDialogDeleteOcorrencia () {
      this.closeDialogOcorrencia()
      this.dialogExcluirOcorrencia = false
    },
    removeOcorrencia () {
      this.salvando = true
      Api.delete(`usinas/${this.usina.uuid_usi_id}/ocorrencias/remove/${this.ocorrencia.uuid_uso_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.message
          })
          this.dialogExcluirOcorrencia = false
          this.salvando = false
          this.closeDialogOcorrencia()
          this.getOcorrencia()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover ocorrência!',
            color: 'error'
          })
        })
    },
    closeDialogOcorrencia () {
      this.ocorrencia = {
        uso_data: '',
        uso_hora: '',
        uso_nome: '',
        uso_tipo: '',
        uso_descricao: '',
        uso_arquivo: []
      }
      if (this.$refs.formOcorrencia) {
        this.$refs.formOcorrencia.resetValidation()
      }
      this.dialogNovaOcorrencia = false
    },
    openDialogImportacao () {
      this.dialogImportacao = true
    },
    closeDialogImportacao () {
      this.importacao = {
        userName: null,
        password: null,
        interface: null,
        appSecret: null,
        appId: null,
        orgId: null
      }
      this.dialogImportacao = false
    },
    async importUsinas () {
      if (!this.$refs.formImportacao.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.importacaoLoading = true
      let endpoint = 'usinas/import-usina-inversor'

      Api.post(endpoint, this.importacao)
        .then((response) => {
          this.importacaoLoading = false
          if (!response.data.status) {
            this.$root.SnackControl.open(this, {
              text: response.data.message,
              color: 'error'
            })
            return false
          }

          this.$root.SnackControl.open(this, {
            text: response.data.message,
            color: 'success'
          })

          this.closeDialogImportacao()
          this.getUsinas()
        })
        .catch((error) => {
          this.importacaoLoading = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    getUser () {
      const userInfo = localStorage.getItem('user')
      this.userInfo = JSON.parse(userInfo)
    },
    isIntegrador () {
      return this.userInfo && this.userInfo.grupo.gru_nome === 'Integrador'
    },
    updateData () {
      if (JSON.parse(localStorage.getItem('user')) !== null && !this.user) {
        this.user = JSON.parse(localStorage.getItem('user'))
        if (this.user.fk_gru_id_grupo) {
          this.nivelUsuarioApelido = 'M'
        }
        if (this.user.fk_dis_id_distribuidor) {
          this.nivelUsuarioApelido = 'D'
        }
        if (this.user.fk_int_id_integrador) {
          this.nivelUsuarioApelido = 'I'
        }
      }
    }
  },
  updated () {
    this.updateData()
  },
  created () {
    this.updateData()
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .v-text-field--outlined .v-input__append-outer, .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 8px!important;
}
.mw_600 {
  max-width: 600px;
}
.max-height_dialog {
  overflow: auto;
  max-height: 400px;
}
.max-height_dialog_small {
  overflow: auto;
  max-height: 250px;
}
.mw_status {
  height: 25px!important;
  min-width: 95px;
  justify-content: center;
  padding: 0 5px!important;
}
.value_area {
  font-size: 14px;
  font-weight: bold;
  line-height: normal;
  margin-top: 3px;
  text-align: right;
}
.value_area_porcentagem {
  font-size: 14px;
  line-break: normal;
  text-align: right;
}
.consulta {
  margin-bottom: 2px;
  min-height: 39px!important;
  width: 100%!important;
}
.add_gerador {
  margin-bottom: 3px;
}
.avatar {
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
  height: 150px;
  margin-right: 15px;
  width: 150px;
}
.v-file-input {
  >>>.v-input__prepend-outer {
    margin-top: 10px!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cadastros/Usina.vue